(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95405],{

/***/ 71069:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(88268);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Index": function() { return /* binding */ Index; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59072);
// EXTERNAL MODULE: ./components/_stores/tooltip-store.tsx
var tooltip_store = __webpack_require__(53137);
// EXTERNAL MODULE: ./components/image.tsx + 1 modules
var components_image = __webpack_require__(53592);
// EXTERNAL MODULE: ./public/images/about/my_photo.jpg
var my_photo = __webpack_require__(86451);
;// CONCATENATED MODULE: ./content/about.tsx
// @ts-ignore


var ABOUT = {
    stats: [
        {
            statistic: "".concat(new Date(Date.now() - new Date("2000-08-15T01:30:00").getTime()).getFullYear() - 1970),
            tooltip: "".concat(Math.round((Date.now() - new Date("2000-08-15T01:30:00").getTime()) / 1000), " seconds"),
            caption: "Years Old"
        },
        {
            statistic: "7+",
            tooltip: "First line of code written in 2016",
            caption: "Years Dev"
        },
        {
            statistic: "1",
            tooltip: "Who also loves running.",
            caption: "Amazing dog"
        },
        {
            statistic: "749",
            tooltip: "13 GitHub Stars",
            caption: "Commits"
        }, 
    ],
    description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "I am a backend developer currently residing in Brazil. I have extensive experience both as a freelancer and as a team member, working with various languages and frameworks. However, my primary focus in recent times has been on the ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Java"
                    }),
                    " ecosystem, particularly using the ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Spring Framework"
                    }),
                    ", ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Cloud"
                    }),
                    ",",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Messaging"
                    }),
                    " and other related technologies."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Since the moment I wrote my first line of code, I knew that this was the professional path I wanted to pursue. I find fulfillment in solving problems and developing innovative, high-impact applications."
            })
        ]
    }),
    images: [
        {
            src: my_photo/* default */.Z,
            alt: "My profile picture"
        }, 
    ]
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./components/sections/about.tsx






var About = function(props) {
    var ref;
    var imageRef = (0,react.useRef)([]);
    var ref1 = (0,react.useState)(0), focusImageIndex = ref1[0], setFocusImageIndex = ref1[1];
    var ref2 = (0,react.useState)(ABOUT.images), images = ref2[0], setImages = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,tooltip_store/* useTooltipStore */._)(), 2), tooltip = ref3[0], setTooltip = ref3[1];
    var buttonRef = (0,react.useRef)(null);
    var handleImageClick = (0,react.useCallback)(function() {
        setTooltip(false);
        if (focusImageIndex === images.length - 1) {
            setFocusImageIndex(function(current) {
                return current + 1;
            });
            setImages(function(current) {
                return current.sort(function() {
                    return 0.5 - Math.random();
                });
            });
            setTimeout(function() {
                setFocusImageIndex(0);
                setTooltip(true);
                var trigger = new Event("mouseover");
                setTimeout(function() {
                    var ref;
                    (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(trigger);
                }, 50);
            }, 350);
        }
        if (focusImageIndex < images.length - 1) {
            setFocusImageIndex(function(current) {
                return current + 1;
            });
            setTimeout(function() {
                setTooltip(true);
                var trigger = new Event("mouseover");
                setTimeout(function() {
                    var ref;
                    (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(trigger);
                }, 50);
            }, 50);
        }
    }, [
        focusImageIndex,
        images.length,
        setTooltip
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "about",
        className: "-mt-12 overflow-hidden pt-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto flex max-w-6xl flex-col justify-center gap-16 px-4 pb-16 md:px-8 lg:grid lg:grid-cols-[540px_auto] lg:pt-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    ref: buttonRef,
                    className: "group relative mx-auto mb-12 aspect-3/2 max-h-[405px] w-full max-w-[540px] flex-1 hfa:outline-none lg:mb-auto lg:mr-0 lg:aspect-4/3",
                    onClick: handleImageClick,
                    type: "button",
                    "data-event": "mouseover",
                    "data-tip": (ref = images[focusImageIndex]) === null || ref === void 0 ? void 0 : ref.alt,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Cycle through Images"
                        }),
                        images.map(function(param, index) {
                            var src = param.src, alt = param.alt;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                maxWidth: 540,
                                src: src,
                                alt: alt,
                                width: 2000,
                                height: 1500,
                                sizes: "(min-width: 580px) 540px, 400px",
                                preload: true,
                                priority: index === 0,
                                className: "absolute left-0 top-0 rounded-xl border-2 border-gray-50/80 object-cover !opacity-0 shadow-lg shadow-gray-700/5 transition-all duration-300 group-focus-visible:border-teal-500 d:border-gray-600/80",
                                "data-about-image-index": index,
                                onLoadingComplete: function() {
                                    return document.querySelectorAll('[data-about-image-index="'.concat(index, '"]')).forEach(function(img) {
                                        return img.classList.remove("!opacity-0");
                                    });
                                },
                                style: {
                                    transform: focusImageIndex > index ? "translate(-700px, -".concat(index % 4 * 60 + 25, "px) rotate(").concat(index % 4 * (index % 2 === 0 ? 0.5 : -1.2) * 3, "deg)") : "rotate(".concat(index % 4 * (index % 2 === 0 ? 0.5 : -1.2) * 3, "deg)"),
                                    zIndex: -index,
                                    filter: focusImageIndex !== index ? "grayscale(80)" : "",
                                    opacity: focusImageIndex > index ? "0" : "1"
                                }
                            }, alt);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative -z-50 h-full w-full -rotate-6 rounded-xl bg-gray-200/80"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "spacing-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "grid max-w-xl grid-cols-2 gap-4 text-center sm:grid-cols-4 sm:text-left",
                            children: ABOUT.stats.map(function(param, index) {
                                var statistic = param.statistic, caption = param.caption, tooltip = param.tooltip;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                    "data-tip": tooltip,
                                    className: "cursor-help select-none spacing-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bg-gradient-to-r from-emerald-500 to-green-600 bg-clip-text text-4xl font-extrabold tracking-tighter text-transparent",
                                            children: statistic
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                            className: "text-[15px] font-semibold tracking-tight text-gray-400 d:text-gray-300/80",
                                            children: caption
                                        })
                                    ]
                                }, caption + index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "tracking tight max-w-3xl leading-relaxed text-gray-500 d:text-gray-100/70 [&>p+p]:mt-4",
                            children: ABOUT.description
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/HeartIcon.js
var HeartIcon = __webpack_require__(85147);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/StarIcon.js
var StarIcon = __webpack_require__(16794);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/MoonIcon.js
var MoonIcon = __webpack_require__(38382);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/SunIcon.js
var SunIcon = __webpack_require__(55330);
// EXTERNAL MODULE: ./components/link.tsx + 1 modules
var components_link = __webpack_require__(56848);
// EXTERNAL MODULE: ./node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(45924);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(90272);
;// CONCATENATED MODULE: ./components/badge.tsx



var Badge = function(param) {
    var children = param.children, _size = param.size, size = _size === void 0 ? "md" : _size, _style = param.style, style = _style === void 0 ? "plain" : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)("inline-flex select-none items-center whitespace-nowrap rounded-md border-2 font-medium transition-all", {
            sm: "px-1.5 py-0.5 text-xs",
            md: "px-2.5 py-0.5 text-[13px]",
            lg: "px-3 py-1 text-[13px]"
        }[size], {
            info: "cursor-pointer border-emerald-700/20 bg-emerald-100 text-emerald-900 hfa:bg-emerald-200/90 d:border-emerald-400/30 d:bg-gradient-to-b d:from-emerald-900/90 d:to-emerald-900/90 d:text-emerald-100 d:hfa:from-emerald-900/70 d:hfa:to-emerald-900/70",
            success: "cursor-pointer border-green-700/20 bg-green-100 text-green-900 hfa:bg-green-200/90 d:border-green-400/30 d:bg-gradient-to-b d:from-green-900/90 d:to-green-900/90 d:text-green-100 d:hfa:from-green-900/70 d:hfa:to-green-900/70",
            attention: "cursor-pointer border-yellow-700/20 bg-yellow-100 text-yellow-900 hfa:bg-yellow-200/90 d:border-yellow-400/30 d:bg-gradient-to-b d:from-yellow-900/90 d:to-yellow-900/90 d:text-yellow-100 d:hfa:from-yellow-900/70 d:hfa:to-yellow-900/70",
            warning: "cursor-pointer border-orange-700/20 bg-orange-100 text-orange-900 hfa:bg-orange-200/90 d:border-orange-400/30 d:bg-gradient-to-b d:from-orange-900/90 d:to-orange-900/90 d:text-orange-100 d:hfa:from-orange-900/70 d:hfa:to-orange-900/70",
            critical: "cursor-pointer border-red-700/20 bg-red-100 text-red-900 hfa:bg-red-200/90 d:border-red-400/30 d:bg-gradient-to-b d:from-red-900/90 d:to-red-900/90 d:text-red-100 d:hfa:from-red-900/70 d:hfa:to-red-900/70",
            accent: "cursor-pointer border-pink-700/20 bg-pink-100 text-pink-900 hfa:bg-pink-200/90 d:border-pink-400/30 d:bg-gradient-to-b d:from-pink-900/90 d:to-pink-900/90 d:text-pink-100 d:hfa:from-pink-900/70 d:hfa:to-pink-900/70",
            plain: "cursor-pointer border-gray-700/20 bg-gray-100 text-gray-900 hfa:bg-gray-200/90 d:border-gray-400/30 d:bg-gradient-to-b d:from-gray-900/90 d:to-gray-900/90 d:text-gray-100 d:hfa:from-gray-900/70 d:hfa:to-gray-900/70",
            disabled: "cursor-not-allowed border-gray-700/5 bg-gray-100 text-gray-400"
        }[style]),
        children: (0,capitalize/* capitalize */.k)(children)
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ClipboardDocumentCheckIcon.js
var ClipboardDocumentCheckIcon = __webpack_require__(37237);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ClipboardDocumentIcon.js
var ClipboardDocumentIcon = __webpack_require__(52535);
// EXTERNAL MODULE: ./components/toast.tsx + 10 modules
var toast = __webpack_require__(51894);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_react-dom@18.2.0_react@18.2.0/node_modules/react-use/esm/useCopyToClipboard.js + 2 modules
var useCopyToClipboard = __webpack_require__(66285);
;// CONCATENATED MODULE: ./components/copy-button.tsx







var CopyButton = function(param) {
    var content = param.content, className = param.className;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCopyToClipboard/* default */.Z)(), 2), state = ref[0], copyToClipboard = ref[1];
    var ref1 = (0,toast/* useToast */.pm)(), toasts = ref1.toasts, addToast = ref1.addToast;
    var handleCopyCode = (0,react.useCallback)(function() {
        copyToClipboard(content);
        addToast({
            id: "copy-code",
            message: "Code Copied to Clipboard",
            timestamp: Date.now()
        });
    }, [
        addToast,
        content,
        copyToClipboard
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (0,clsx_m/* default */.Z)(className, "h-5 w-5 transition-colors"),
        onClick: handleCopyCode,
        type: "button",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Copy code"
            }),
            toasts.some(function(notification) {
                return notification.id === "copy-code";
            }) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardDocumentCheckIcon/* default */.Z, {
                className: "h-5 w-5 text-teal-400"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardDocumentIcon/* default */.Z, {
                className: "h-5 w-5"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(57135);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(99938);
// EXTERNAL MODULE: ./node_modules/.pnpm/prismjs@1.29.0/node_modules/prismjs/prism.js
var prism = __webpack_require__(35488);
;// CONCATENATED MODULE: ./components/typography/code.tsx






var Code = function(param) {
    var language = param.language, plugins = param.plugins, lineHighlight = param.lineHighlight, code = param.code, className = param.className;
    var loadDependencies = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        __webpack_require__(96316)("./prism-".concat(language))
                    ];
                case 1:
                    _state.sent();
                    if (!(plugins === null || plugins === void 0 ? void 0 : plugins.includes("line-numbers"))) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 16518).then(__webpack_require__.t.bind(__webpack_require__, 16518, 23))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (!(plugins === null || plugins === void 0 ? void 0 : plugins.includes("highlight-keywords"))) return [
                        3,
                        5
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 95120).then(__webpack_require__.t.bind(__webpack_require__, 95120, 23))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    if (!lineHighlight) return [
                        3,
                        7
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 97288).then(__webpack_require__.t.bind(__webpack_require__, 97288, 23))
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    (0,prism.highlightAll)();
                    return [
                        2
                    ];
            }
        });
    }), [
        language,
        lineHighlight,
        plugins
    ]);
    (0,react.useEffect)(function() {
        loadDependencies();
    }, [
        language,
        loadDependencies
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
        className: (0,clsx_m/* default */.Z)(plugins, lineHighlight && "line-highlight", "language-".concat(language), className),
        "data-line": lineHighlight,
        tabIndex: -1,
        children: (Array.isArray(code) ? code : [
            code
        ]).map(function(code, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        className: "language-".concat(language),
                        "data-selected-index": index,
                        children: code
                    }),
                    "\n"
                ]
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./components/code-editor.tsx



var CodeEditor = function(param) {
    var code = param.code, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: "relative w-full flex-col overflow-hidden rounded-md border-2 border-gray-200/40 bg-gray-900 p-2.5 shadow-2xl drop-shadow-lg d:border-gray-600/40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "mb-2 grid items-center border-b border-b-gray-800 pb-2",
                style: {
                    gridTemplateColumns: "50px 1fr 50px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                        className: "flex gap-1.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: -1,
                                "aria-hidden": true,
                                className: "h-3 w-3 rounded-full bg-gray-700 transition-colors h:bg-[#EC6A5F]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: -1,
                                "aria-hidden": true,
                                className: "h-3 w-3 rounded-full bg-gray-700 transition-colors h:bg-[#F4BF50]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: -1,
                                "aria-hidden": true,
                                className: "h-3 w-3 rounded-full bg-gray-700 transition-colors h:bg-[#61C454]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "color select-none text-center text-[13px] leading-none tracking-wide text-gray-500",
                        children: "/Welcome.java"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                            content: Array.isArray(code) ? code.join("\n") : code,
                            className: "text-gray-500 hf:text-white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: " relative h-[calc(100%-37px)] overflow-hidden before:absolute b:pointer-events-none b:bottom-0 b:z-10 b:h-12 b:w-full b:select-none b:bg-gradient-to-b b:from-transparent b:to-gray-900",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sm:scrollbar-none relative h-full overflow-auto ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                        className: "text-[13px]",
                        code: code,
                        language: language
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@headlessui+react@1.7.17_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/switch/switch.js + 9 modules
var switch_switch = __webpack_require__(8224);
;// CONCATENATED MODULE: ./components/toggle-switch.tsx




var ToggleSwitch = function(param) {
    var enabled = param.enabled, setEnabled = param.setEnabled, enabledIcon = param.enabledIcon, disabledIcon = param.disabledIcon;
    var ref;
    var switchRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_switch/* Switch */.r, {
            ref: switchRef,
            checked: enabled,
            onChange: setEnabled,
            className: (0,clsx_m/* default */.Z)(enabled ? " from-pink-400 to-violet-500" : "from-yellow-200 to-orange-300", "relative h-9 w-16 flex-shrink-0 cursor-pointer rounded-full border-2 border-gray-500/40 bg-gradient-to-r bg-clip-padding p-0.5 transition-colors duration-200 ease-in-out focus:outline-none"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Switch Color Theme"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(enabled ? "translate-x-[calc(100%)]" : "translate-x-0", "pointer-events-none relative aspect-1 h-full transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"),
                    style: {
                        transform: enabled ? "translateX(calc(".concat((ref = switchRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth, "px - 100% - 4px))") : "translateX(0px)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: (0,clsx_m/* default */.Z)(enabled ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in", "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"),
                            "aria-hidden": "true",
                            children: disabledIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: (0,clsx_m/* default */.Z)(enabled ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out", "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"),
                            "aria-hidden": "true",
                            children: enabledIcon
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var toggle_switch = (ToggleSwitch);

;// CONCATENATED MODULE: ./components/linkedin-profile.tsx



var LinkedinProfile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "max-w-xs animate-float rounded-lg border-2 border-gray-400/30 bg-white/90 p-4 backdrop-blur-md will-change-transform spacing-2 d:bg-gray-800 lg:bg-white/80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "flex gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        className: "overflow-hidden rounded-full border-2 border-gray-400/50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                            width: 40,
                            height: 40,
                            src: "https://avatars.githubusercontent.com/u/52140952",
                            alt: "Mateus",
                            className: "rounded-full border-2 border-accent"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-sm font-semibold tracking-wide",
                                children: "Mateus"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-sm tracking-tight text-gray-500 d:text-gray-300/90",
                                children: "@mateusneresrb"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                        target: "_blank",
                        href: "https://www.linkedin.com/in/mateusneresrb/",
                        className: "butter-border my-auto ml-auto flex items-center justify-center rounded-full bg-teal-500/90 py-1.5 px-4 text-xs text-white transition-colors hfa:bg-teal-600/80 d:bg-teal-600/90 d:hfa:bg-teal-500/80",
                        children: "Connect"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pr-2 text-[13px] tracking-tight text-gray-500/90 line-clamp-3 d:text-gray-300/90",
                    children: "My professional space, I share insights about my career, personal projects, and topics from the world of programming."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-[13px] text-gray-500 d:text-gray-300/90",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-semibold text-gray-600 d:text-gray-200",
                            children: "3.015"
                        }),
                        " Followers",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-2 font-semibold text-gray-600 d:text-gray-200",
                            children: "2.600"
                        }),
                        " ",
                        "Connections"
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/raw-loader@4.0.2_webpack@5.88.2/node_modules/raw-loader/dist/cjs.js!./content/code-blocks/hero.tsx
/* harmony default export */ var hero = ("import org.springframework.web.bind.annotation.GetMapping;\nimport org.springframework.web.bind.annotation.RequestMapping;\nimport org.springframework.web.bind.annotation.RestController;\n\n@RestController\n@RequestMapping(value = \"/welcome\")\npublic class Welcome {\n    \n    @GetMapping\n    public String sayHello() {\n        return \"Hello, it's Mateus Neres website!\";\n    }\n}");
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-icons+all-files@4.1.0_react@18.2.0/node_modules/@react-icons/all-files/si/SiSpring.js
var SiSpring = __webpack_require__(5392);
// EXTERNAL MODULE: ./content/tech-stack.tsx + 22 modules
var tech_stack = __webpack_require__(33487);
;// CONCATENATED MODULE: ./content/hero.tsx
// @ts-ignore

 // Adding `!!` to a request will disable all loaders specified in the configuration


var HERO = {
    pre: "Welcome to my site.",
    heading: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "I'm ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Mateus Neres"
            }),
            ", a Backend developer."
        ]
    }),
    tech: [
        tech_stack/* TECH.java */.O.java,
        {
            name: "Spring",
            Icon: function(param) {
                var className = param.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiSpring/* SiSpring */.C, {
                    className: className
                });
            }
        },
        tech_stack/* TECH.redis */.O.redis,
        tech_stack/* TECH.jenkins */.O.jenkins,
        tech_stack/* TECH.aws */.O.aws, 
    ],
    body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "I'm a passionate programming enthusiast, constantly striving to tackle a wide range of challenges using my coding skills. Whether it's automating tasks or integrating with APIs, I've been immersed in the world of programming for several years now.",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mt-4 block"
            }),
            "My passion is to explore the endless possibilities that programming offers and discover innovative solutions to problems.",
            " "
        ]
    }),
    cta1: {
        href: "mailto:contato@mateusneres.dev",
        name: "Let's Work"
    },
    cta2: {
        href: "/resume",
        name: "Resume"
    },
    code: "".concat(hero)
};

// EXTERNAL MODULE: ./node_modules/.pnpm/next-themes@0.2.1_next@12.3.4_react-dom@18.2.0_react@18.2.0/node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(64062);
;// CONCATENATED MODULE: ./components/sections/hero.tsx









var Hero = function() {
    var ref = (0,index_module/* useTheme */.F)(), theme = ref.theme, setTheme = ref.setTheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "hero relative overflow-hidden pb-40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative mx-auto flex max-w-6xl grid-cols-3 flex-col gap-8 gap-y-16 px-4 py-16 md:py-32 md:px-8 lg:grid",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "col-span-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "heading-pre",
                                    children: HERO.pre
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "heading-hero ",
                                    children: HERO.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "sm:scrollbar-none -mx-4 mb-2 flex items-center gap-6 overflow-x-auto px-4 pb-2 text-[15px] font-medium",
                                    children: HERO.tech.map(function(param) {
                                        var name = param.name, Icon = param.Icon;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex items-center gap-2 text-gray-500 d:text-gray-400",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                    className: "h-7 w-7 text-gray-400 d:text-gray-300/80"
                                                }),
                                                name
                                            ]
                                        }, name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-3 max-w-prose font-normal text-gray-500 d:text-gray-400 md:text-lg md:tracking-tight",
                                    children: HERO.body
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-3 max-w-xl font-normal text-gray-500 md:text-lg md:tracking-tight"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                            className: "mt-6 flex flex-wrap gap-4 md:gap-8",
                            children: [
                                HERO.cta1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                    href: HERO.cta1.href,
                                    className: "button-rainbow inline-flex whitespace-nowrap bg-gray-800 px-10 py-2.5 text-sm font-medium tracking-tight text-gray-50 hfa:border-gray-300/90 hfa:bg-gray-900 hfa:text-white d:hfa:border-gray-700/30 md:px-12",
                                    children: HERO.cta1.name
                                }) : null,
                                HERO.cta2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                    href: HERO.cta2.href,
                                    className: "button-border inline-flex whitespace-nowrap bg-white/90 px-10 py-2.5 text-sm font-medium tracking-tight text-gray-500 transition-all hfa:border-gray-900/70 hfa:bg-white/90 hfa:text-gray-900 d:border-gray-700/80 d:bg-transparent d:text-gray-300 d:hfa:border-gray-200/30 d:hfa:bg-gray-900/80 d:hfa:text-gray-50 md:px-12",
                                    children: HERO.cta2.name
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "relative md:h-[420px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex h-full min-w-[460px] flex-col gap-4 sm:min-w-[660px] lg:absolute lg:left-8 lg:top-16 lg:left-6 lg:top-24 lg:min-w-[460px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative z-20 flex justify-end gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "info",
                                            children: "Traveler"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "warning",
                                            children: "Fitness"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "accent",
                                            children: "Coffee Lover"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "plain",
                                            children: "Space Enthusiast"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative flex h-full flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeEditor, {
                                            code: HERO.code,
                                            language: "java"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute -right-5 -bottom-5 -z-10 h-[calc(100%+1.25rem)] w-[calc(100%+1.25rem)] rounded-lg border border-gray-400/20 bg-gray-100/70 [mask-image:linear-gradient(-30deg,#fff_16.35%,rgb(255_255_255_/_0%)_61.66%)] d:border-gray-700/20 d:bg-gray-900/40"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "z-10 mt-1 flex gap-2 lg:-mt-2 lg:ml-16",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                            target: "_blank",
                                            href: "https://www.buymeacoffee.com/mateusneresrb",
                                            className: "group flex items-center justify-center rounded-full border-2 border-gray-400/50 bg-gray-100 bg-clip-padding py-1.5 px-3 text-sm font-medium text-gray-600 transition-all hfa:border-rose-500/30 hfa:bg-rose-500 hfa:text-white d:bg-gray-700 d:text-gray-50 d:hfa:bg-rose-500",
                                            "data-tip": "Buy me a coffee",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeartIcon/* default */.Z, {
                                                    className: "mr-1 h-4 w-4 animate-heartbeat text-red-600 transition-all group-hfa:text-white"
                                                }),
                                                "Support"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                            target: "_blank",
                                            href: "https://github.com/mateusneresrb/my-website",
                                            className: "group flex h-9 w-9 items-center justify-center rounded-full border-2 border-gray-400/50 bg-gray-100 bg-clip-padding text-sm font-medium text-gray-600 transition-all hfa:border-yellow-500/30 hfa:bg-yellow-500 hfa:text-white d:bg-gray-700 d:text-gray-50 d:hfa:bg-yellow-500",
                                            "data-tip": "Star on Github",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Star on Github"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                                                    className: "h-4 w-4 text-yellow-500 group-hfa:text-white"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_switch, {
                                            enabled: theme === "dark",
                                            setEnabled: function(bool) {
                                                return setTheme(bool ? "dark" : "light");
                                            },
                                            enabledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonIcon/* default */.Z, {
                                                className: "h-3 w-3 text-slate-400"
                                            }),
                                            disabledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SunIcon/* default */.Z, {
                                                className: "h-4 w-4 text-orange-400"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute hidden sm:top-24 sm:-right-5 sm:block lg:top-full lg:-left-64",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinProfile, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "background pointer-events-none absolute inset-0 z-1 -z-30 select-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative top-1/2 left-1/2 h-2/3 w-1/2 -translate-y-[30%] rounded-full bg-gradient-radial from-emerald-600/30 to-teal-600/5 blur-2xl"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(80564);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9970);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/LinkIcon.js
var LinkIcon = __webpack_require__(35385);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-icons+all-files@4.1.0_react@18.2.0/node_modules/@react-icons/all-files/fa/FaGithub.js
var FaGithub = __webpack_require__(25494);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ArrowLongLeftIcon.js
var ArrowLongLeftIcon = __webpack_require__(24090);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ArrowLongRightIcon.js
var ArrowLongRightIcon = __webpack_require__(36668);
// EXTERNAL MODULE: ./utils/scroll-to.tsx
var scroll_to = __webpack_require__(17956);
;// CONCATENATED MODULE: ./components/scroll-gallery.tsx




var ScrollGallery = function(param) {
    var itemWidth = param.itemWidth, gapWidth = param.gapWidth, children = param.children, filter = param.filter;
    var scrollContainerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        prev: false,
        next: true
    }), scrollNavigation = ref[0], setScrollNavigation = ref[1];
    var ref1 = (0,react.useState)(false), isScrolling = ref1[0], setIsScrolling = ref1[1];
    var handleClickPrevious = (0,react.useCallback)(function() {
        if (isScrolling) return;
        var scrollContainer = scrollContainerRef.current;
        scrollContainer.classList.remove("snap-x");
        setIsScrolling(true);
        (0,scroll_to/* scrollToX */.T)(200, Math.max((scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft) - itemWidth - gapWidth, 0), scrollContainer, function() {
            setIsScrolling(false);
            scrollContainer.classList.add("snap-x");
        });
    }, [
        gapWidth,
        isScrolling,
        itemWidth
    ]);
    var handleClickNext = (0,react.useCallback)(function() {
        if (isScrolling) return;
        var scrollContainer = scrollContainerRef.current;
        scrollContainer.classList.remove("snap-x");
        setIsScrolling(true);
        (0,scroll_to/* scrollToX */.T)(200, scrollContainer.scrollLeft + itemWidth + gapWidth, scrollContainer, function() {
            setIsScrolling(false);
            scrollContainer.classList.add("snap-x");
        });
    }, [
        gapWidth,
        isScrolling,
        itemWidth
    ]);
    (0,react.useEffect)(function() {
        var scrollContainer = scrollContainerRef.current;
        var updateScrollNavigation = function() {
            setScrollNavigation(function() {
                var ref;
                return {
                    prev: (scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft) > 0,
                    next: ((ref = scrollContainer.children[scrollContainer.children.length - 1]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().right) > window.innerWidth
                };
            });
        };
        scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.addEventListener("scroll", updateScrollNavigation);
        return function() {
            scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.removeEventListener("scroll", updateScrollNavigation);
        };
    }, []);
    (0,react.useEffect)(function() {
        var scrollContainer = scrollContainerRef.current;
        scrollContainer.classList.remove("snap-x");
        setIsScrolling(true);
        (0,scroll_to/* scrollToX */.T)(200, 0, scrollContainer, function() {
            setIsScrolling(false);
            scrollContainer.classList.add("snap-x");
        });
    }, [
        filter,
        gapWidth,
        itemWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "sm:scrollbar-none group relative flex snap-x snap-mandatory scroll-pl-[max(var(--slider-padding),calc((100%-72rem)/2+var(--slider-padding)))] gap-8 overflow-x-auto py-12 px-[max(var(--slider-padding),calc((100%-72rem)/2+var(--slider-padding)))] [--slider-padding:2rem]",
                    ref: scrollContainerRef,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "absolute left-10 bottom-0 hidden items-center gap-2 py-2 px-4 text-sm text-gray-500 transition-all duration-75 disabled:text-gray-300 h:text-gray-900 disabled:h:text-gray-300 d:text-gray-300 d:disabled:text-gray-700 d:hfa:text-gray-50 d:disabled:hfa:text-gray-700 md:flex",
                    onClick: handleClickPrevious,
                    disabled: !scrollNavigation.prev,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLongLeftIcon/* default */.Z, {
                            className: "mt-0.5 h-5 w-5"
                        }),
                        "prev"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "absolute right-10 bottom-0 hidden items-center gap-2 py-2 px-4 text-sm text-gray-500 transition-all duration-75 disabled:text-gray-300 h:text-gray-900 h:text-gray-900 disabled:h:text-gray-300 d:text-gray-300 d:disabled:text-gray-700 d:hfa:text-gray-50 d:disabled:hfa:text-gray-700 md:flex",
                    onClick: handleClickNext,
                    disabled: !scrollNavigation.next,
                    children: [
                        "next",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLongRightIcon/* default */.Z, {
                            className: "mt-0.5 h-5 w-5"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./content/portfolio-preview.tsx
var PORTFOLIO = {
    pre: "Portfolio",
    heading: "Checkout my work."
};

;// CONCATENATED MODULE: ./public/images/projects/ChatGPTStyle.jpg
/* harmony default export */ var ChatGPTStyle = ({"src":"/_next/static/media/ChatGPTStyle.2b466db9.jpg","height":400,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIxA1H/xAAVAQEBAAAAAAAAAAAAAAAAAAAAA//EABkRAAEFAAAAAAAAAAAAAAAAAAABAgMycf/aAAwDAQACEQMRAD8AicOovq6x56AATjo3EP/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/projects/Futurium.png
/* harmony default export */ var Futurium = ({"src":"/_next/static/media/Futurium.7d80eaa1.png","height":1002,"width":1903,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEUTEhIeGx1BIjYiEBwsFzc0GzACBQRdLk5SJkFZF3WSRIiZyA0TAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVR4nAXBBwEAMAzDMOd0jz/gScSeeiBn+75ZoKQFkITEBwg4AF6ZFWkSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/WorkSo.png
/* harmony default export */ var WorkSo = ({"src":"/_next/static/media/WorkSo.f11e9919.png","height":223,"width":517,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAACVBMVEUMDQ0VFRYhISJxnJWMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGUlEQVR4nGNgYgQBBgYGJiYmMM3AxMgEpgEBZQAWsJzE5AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/images/projects/Bytechat.png
/* harmony default export */ var Bytechat = ({"src":"/_next/static/media/Bytechat.be4c0a25.png","height":603,"width":837,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAG1BMVEU2NkcYGhwvMD46QVUEBQMoJzQ9UG88Smc8P0/htJGQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nD3GMRIAMAgCQRDQ///YMUWuuFmQhCTBNqd7kKR0KLwKuZP+WA8kAHzgwWn1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/projects/VibedePet.jpg
/* harmony default export */ var VibedePet = ({"src":"/_next/static/media/VibedePet.52077d45.jpg","height":1350,"width":1080,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAYDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAaEAEAAwADAAAAAAAAAAAAAAACAAEDEjGB/8QAFAEBAAAAAAAAAAAAAAAAAAAABv/EABoRAAMAAwEAAAAAAAAAAAAAAAECAwAEIWH/2gAMAwEAAhEDEQA/AL7osE65jQ9nkauvIiITe9ZMURiAPcQ68p1mKMOnuf/Z","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/projects/Cobybot.jpg
/* harmony default export */ var Cobybot = ({"src":"/_next/static/media/Cobybot.be268703.jpg","height":957,"width":1458,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAgEFAQAAAAAAAAAAAAABAwACBAUTISJRkf/EABUBAQEAAAAAAAAAAAAAAAAAAAAC/8QAGREAAQUAAAAAAAAAAAAAAAAAAAECERIx/9oADAMBAAIRAxEAPwCHW/EwsW6jp6nXak03GEk1sCew8PI+RERCEUbp/9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/projects/TuroRobot.png
/* harmony default export */ var TuroRobot = ({"src":"/_next/static/media/TuroRobot.efd7f715.png","height":944,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAYFBMVEX9/f3K0M7X19Gen5j6+vrg3+Pd3d3q6unz8/OEZGaZJjB1ZV5VRUKJVVenJi9eYlxEOkTv7vGxsa+2tbWqcHE3EBfJlI4fICOkPkF8PT6NjohMW1yvqaF9ERvWsaZyfXj7OThsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARElEQVR4nB3GSRKAIBAAsUaEAQTBfdf//9LSyiXs+Xhyc1boJsZS/M28hja0V2Kcli15r6n6QSkRoTPWWAdQf+QvIO4FfcQCo3Vbk8wAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/projects/InstaRobot.jpeg
/* harmony default export */ var InstaRobot = ({"src":"/_next/static/media/InstaRobot.48720b41.jpeg","height":1024,"width":1024,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAEAAgECBwAAAAAAAAAAAAABAAMCBBEFBhIUMVFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAWEQEBAQAAAAAAAAAAAAAAAAAAATH/2gAMAwEAAhEDEQA/ALvCvXPM91t3EDswy6aCxRUNvmwPj3ERFidf/9k=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/projects/PixPayView.png
/* harmony default export */ var PixPayView = ({"src":"/_next/static/media/PixPayView.e9c5850a.png","height":364,"width":524,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAOVBMVEX///+z1s/V7enG4dy3ur18vKmx08663NXU193w8vNytqOdvbXi7+1ikoWYkZNksZvGw8f4+Pjm5Oa2XCmlAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nBXGWRLAIAgFwVGBB2Yxuf9lLfurqcrMwlALRXRjqF1SNyDfH07uUfDhPtd0fzYdNwEgrL8pTgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/projects/StockManager.png
/* harmony default export */ var StockManager = ({"src":"/_next/static/media/StockManager.9882e332.png","height":546,"width":822,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAABlBMVEUfKC0nLjN92yL4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAF0lEQVR4nGNgYGBgZGRgYGRghAIG3AAAAZ8ADOnO5DkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/projects/Game2048.png
/* harmony default export */ var Game2048 = ({"src":"/_next/static/media/Game2048.fdd2b533.png","height":336,"width":522,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAHlBMVEUMDAwTExUbGhktR2gjLEAZHCofMWFbVVVVT0w3WoZ6eSgHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nB3JuREAMAzDMFqS8+y/cM5Bw4LobDESSQXY6Snruv+rATwIagBR1k5WlAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/projects/SearchApartments.png
/* harmony default export */ var SearchApartments = ({"src":"/_next/static/media/SearchApartments.00d6032a.png","height":750,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAM1BMVEX////g39yaiHiQcle1tLHe3Nm3r6Xh6/XLw72rpZ7v7uzFvbqmkoWIgXmzub7l5eGjoZ+h/hrRAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAMElEQVR4nBXIyREAIAgAsVVAwLv/ah3zDPRidjqguTUDaPVmDmBJlflHY7QwAHd3eB1ZAQOMZPidAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/projects/DragonPvP.jpg
/* harmony default export */ var DragonPvP = ({"src":"/_next/static/media/DragonPvP.c1cb5e67.jpg","height":480,"width":640,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDBRESEyEx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAMAwEAAhEDEQA/AIWGzqjE/lrwT2BrE0YGfUREbUjl/9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./content/projects.tsx














var PROJECTS = [
    {
        name: "CobyBot",
        type: [
            "Application"
        ],
        tech: [
            tech_stack/* TECH.javascript */.O.javascript,
            tech_stack/* TECH.jest */.O.jest,
            tech_stack/* TECH.aws */.O.aws,
            tech_stack/* TECH.express */.O.express
        ],
        year: "2023",
        url: "https://cobybot.com/",
        description: "Coby is a virtual assistant for WhatsApp that aims to serve and help everyone who needs it, using the OpenAI API.",
        featuredImage: Cobybot
    },
    {
        name: "StockManager",
        type: [
            "Application"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.gradle */.O.gradle,
            tech_stack/* TECH.swing */.O.swing,
            tech_stack/* TECH.lombok */.O.lombok,
            tech_stack/* TECH.gson */.O.gson,
            tech_stack/* TECH.mysql */.O.mysql
        ],
        year: "2023",
        repository: "https://github.com/mateusneresrb/stockmanager",
        description: "The project was a work for the OOP 2 (Object-Oriented Programming 2) course at the university. I developed a stock management system in Java using Swing. It includes authentication and saves data in a database.",
        featuredImage: StockManager
    },
    {
        name: "ByteChat",
        type: [
            "Application"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.gradle */.O.gradle,
            tech_stack/* TECH.swing */.O.swing,
            tech_stack/* TECH.lombok */.O.lombok,
            tech_stack/* TECH.gson */.O.gson
        ],
        year: "2023",
        repository: "https://github.com/mateusneresrb/bytechat",
        description: "The project involves the development of an application for the distributed systems course, so I developed a real-time chat system using sockets and Swing for all the visual parts.",
        featuredImage: Bytechat
    },
    {
        name: "ChatGPT Style",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.html_5 */.O.html_5,
            tech_stack/* TECH.javascript */.O.javascript,
            tech_stack/* TECH.css_3 */.O.css_3
        ],
        year: "2023",
        url: "https://chrome.google.com/webstore/detail/chatgpt-style/ooefjbdchgdlfeigfhigjpffppdklnef",
        repository: "https://github.com/mateusneresrb/chatgpt-style",
        description: "It’s a browser extension for browsers based on the Chrome engine, which allows you to modify the styling of ChatGPT",
        featuredImage: ChatGPTStyle
    },
    {
        name: "PixPayView",
        type: [
            "API's"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.spring */.O.spring,
            tech_stack/* TECH.mysql */.O.mysql,
            tech_stack/* TECH.postman */.O.postman
        ],
        year: "2023",
        repository: "https://github.com/mateusneresrb/pixpayview-backend",
        description: "I developed the backend of an application that allowed employers to give permission for employees to generate PIX payment QR-Codes and view when the purchase was approved, using the Mercado Pago API.",
        featuredImage: PixPayView
    },
    {
        name: "2048 Game",
        type: [
            "Terminal"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.git */.O.git,
            tech_stack/* TECH.lombok */.O.lombok
        ],
        year: "2022",
        repository: "https://github.com/mateusneresrb/Game_2048",
        description: "I developed the 2048 game as a project for the OOP (Object-Oriented Programming) course at the university, managing to bring a friendly appearance, even though it was in the terminal.",
        featuredImage: Game2048
    },
    {
        name: "WorkSo",
        type: [
            "Terminal"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.git */.O.git,
            tech_stack/* TECH.lombok */.O.lombok
        ],
        year: "2022",
        repository: "https://github.com/mateusneresrb/WorkSo",
        description: "In this project, the goal was to simulate scheduling algorithms for the operating systems course at the university. I developed the system in Java with a user-friendly interface in the terminal.",
        featuredImage: WorkSo
    },
    {
        name: "Futurium",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.html_5 */.O.html_5,
            tech_stack/* TECH.mysql */.O.mysql,
            tech_stack/* TECH.aws */.O.aws,
            tech_stack/* TECH.redis */.O.redis
        ],
        year: "2021",
        url: "https://futurium.com.br/",
        description: "I actively worked as the development leader of this server and developed dozens of crucial systems for it.",
        featuredImage: Futurium
    },
    {
        name: "Vibe de Pet",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.javascript */.O.javascript,
            tech_stack/* TECH.sass */.O.sass
        ],
        year: "2021",
        description: "I was part of the development team for this e-commerce for pets, working specifically on the frontend in the conception of the theme.",
        featuredImage: VibedePet
    },
    {
        name: "TuroRobot",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.selenium */.O.selenium,
            tech_stack/* TECH.chrome */.O.chrome,
            tech_stack/* TECH.git */.O.git
        ],
        year: "2020",
        description: "It’s an automation performed in Java that facilitates rentals on the Turo site, automates the sharing of images among rentals and automatic messages.",
        featuredImage: TuroRobot
    },
    {
        name: "SearchApartments",
        type: [
            "Automation"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.selenium */.O.selenium,
            tech_stack/* TECH.chrome */.O.chrome,
            tech_stack/* TECH.git */.O.git
        ],
        year: "2020",
        description: "It’s an automatic system for finding apartments on a Stockholm website and sending an email if it finds any that match the desired specifications.",
        featuredImage: SearchApartments
    },
    {
        name: "InstaRobot",
        type: [
            "Automation"
        ],
        tech: [
            tech_stack/* TECH.prettier */.O.prettier,
            tech_stack/* TECH.eslint */.O.eslint,
            tech_stack/* TECH.typescript */.O.typescript
        ],
        year: "2020",
        description: "An automated account system for use in Instagram raffles, based on tagging accounts in comments.",
        featuredImage: InstaRobot
    },
    {
        name: "PvPUtils",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.java */.O.java,
            tech_stack/* TECH.git */.O.git,
            tech_stack/* TECH.intellij_idea */.O.intellij_idea
        ],
        year: "2020",
        description: "A mod for the Minecraft game that added extra features to the game, such as autoclicker, auto-armor among other functionalities.",
        featuredImage: DragonPvP
    }, 
];

;// CONCATENATED MODULE: ./components/sections/portfolio-preview.tsx












var PortfolioPreview = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)("All Projects"), filter = ref[0], setFilter = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "portfolio",
        className: "portfolio-preview mb-24 min-h-full spacing-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "mx-auto grid w-full max-w-6xl px-4 md:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "heading-pre",
                        children: PORTFOLIO.pre
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "heading-2xl -ml-1",
                        children: PORTFOLIO.heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative -mx-4 overflow-x-auto px-4 pb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                            className: "flex gap-3",
                            onChange: function(e) {
                                return setFilter(e.target.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                    className: "sr-only",
                                    children: "Filter by Tag"
                                }),
                                [
                                    "All Projects"
                                ].concat((0,_to_consumable_array/* default */.Z)(new Set(PROJECTS.map(function(p) {
                                    return p.type;
                                }).flat()))).map(function(type, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "radio",
                                                className: "peer hidden",
                                                defaultChecked: index === 0,
                                                name: "Tag Filter",
                                                value: type
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer appearance-none whitespace-nowrap rounded-full border border-gray-200 bg-gray-400/10 py-1 px-3 text-[13px] font-medium text-gray-400 transition-colors peer-checked:text-gray-900 hfa:text-gray-500 d:border-gray-700 d:peer-checked:text-gray-50 d:hfa:text-gray-300",
                                                children: type
                                            })
                                        ]
                                    }, type);
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollGallery, {
                itemWidth: 340,
                gapWidth: 32,
                filter: filter,
                children: PROJECTS.map(function(project, index) {
                    var ref;
                    var rotationIndex = PROJECTS.filter(function(param) {
                        var type = param.type;
                        return filter === "All Projects" || type.includes(filter);
                    }).findIndex(function(param) {
                        var name = param.name;
                        return project.name === name;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (0,clsx_m/* default */.Z)("relative h-[380px] w-[340px] min-w-[340px] snap-start rounded-xl border-2 border-gray-700/30 bg-clip-padding p-4 shadow-xl transition-[min-width,width,margin-left,opacity] duration-300 spacing-0 d:border-white/20", filter === "All Projects" || project.type.includes(filter) ? "flex" : "-ml-8 !w-0 !min-w-0 !overflow-hidden !border-0 !px-0 opacity-20", rotationIndex % 2 === 0 && "sm:rotate-[1.5deg]", rotationIndex % 2 === 1 && "sm:rotate-[-1.5deg]", index % 8 === 0 && "shadow-[currentBg] bg-[linear-gradient(40deg,var(--tw-gradient-stops))] from-pink-300/80 to-violet-500/40 shadow-violet-500/20", index % 8 === 1 && "bg-[linear-gradient(120deg,var(--tw-gradient-stops))] from-yellow-300/80 to-rose-600/80 shadow-rose-600/20", index % 8 === 2 && "bg-[linear-gradient(180deg,var(--tw-gradient-stops))] from-gray-200/40 to-rose-500/80 shadow-rose-500/20", index % 8 === 3 && "bg-[linear-gradient(120deg,var(--tw-gradient-stops))] from-green-400/70 to-emerald-600/80 shadow-emerald-600/20", index % 8 === 4 && "bg-[linear-gradient(140deg,var(--tw-gradient-stops))] from-orange-500/50 to-yellow-500/80 shadow-yellow-500/20", index % 8 === 5 && "bg-[linear-gradient(200deg,var(--tw-gradient-stops))] from-purple-500/80 to-teal-600/40 shadow-teal-600/20", index % 8 === 6 && "bg-[linear-gradient(70deg,var(--tw-gradient-stops))] from-emerald-400/80 to-teal-600/40 shadow-teal-600/20", index % 8 === 7 && "bg-[linear-gradient(140deg,var(--tw-gradient-stops))] from-emerald-400/80 to-indigo-700/50 shadow-indigo-700/20"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                style: {
                                    maxHeight: "160px"
                                },
                                className: "relative flex aspect-2 w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                    preload: true,
                                    src: project.featuredImage,
                                    alt: project.name,
                                    width: 400,
                                    height: 200,
                                    maxWidth: 320,
                                    className: "rounded-t-lg object-cover object-center [mask-image:linear-gradient(180deg,#fff_16.35%,rgb(255_255_255_/_0%)_91.66%)]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tighter text-gray-800 d:text-white",
                                        children: project.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-0.5 -ml-0.5 flex items-center gap-2 tracking-tight text-gray-600 d:text-gray-200",
                                        children: (ref = project.tech) === null || ref === void 0 ? void 0 : ref.map(function(param, i) {
                                            var name = param.name, Icon = param.Icon;
                                            if (i > 3) return null;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex select-none items-center gap-1 whitespace-nowrap rounded border border-gray-700/10 bg-gray-200/30 py-[2px] px-1.5 text-[13px] font-medium hfa:bg-gray-200/60 d:bg-gray-900/20 d:text-gray-50/80 d:hfa:bg-gray-900/30",
                                                children: name
                                            }, name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "mt-2 text-[15px] tracking-tight text-gray-600 d:text-gray-200 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    title: project.description,
                                    className: "line-clamp-4",
                                    children: project.description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                className: "absolute bottom-3 left-0 mt-auto flex w-full items-end justify-end gap-2 px-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mr-auto text-sm font-semibold text-gray-700/80 d:text-gray-300/80",
                                        children: project.year
                                    }),
                                    project.repository ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        target: "_blank",
                                        href: project.repository,
                                        className: "p-1 text-gray-700/80 transition-all hfa:text-gray-900 d:text-gray-300/80 d:hfa:text-gray-50",
                                        "data-tip": "View repository",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Link to Github repository"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGithub/* FaGithub */.h, {
                                                className: "h-5 w-5 "
                                            })
                                        ]
                                    }) : null,
                                    project.url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        target: "_blank",
                                        href: project.url,
                                        className: "p-1 text-gray-700/80 transition-all hfa:text-gray-900 d:text-gray-300/80 d:hfa:text-gray-50",
                                        "data-tip": "View site",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Link to Project"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkIcon/* default */.Z, {
                                                className: "h-5 w-5 "
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }, project.name);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/_hooks/use-debounce-effect.tsx


var useDebouncedEffect = function(effect, delay, deps) {
    (0,react.useEffect)(function() {
        var handler = setTimeout(function() {
            return effect();
        }, delay);
        return function() {
            return clearTimeout(handler);
        };
    // using || operator because
    // if its optional then it can be undefined.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, (0,_to_consumable_array/* default */.Z)(deps || []).concat([
        delay
    ]));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/WifiIcon.js
var WifiIcon = __webpack_require__(4690);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/ComputerDesktopIcon.js
var ComputerDesktopIcon = __webpack_require__(68951);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/CodeBracketIcon.js
var CodeBracketIcon = __webpack_require__(28856);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/CodeBracketSquareIcon.js
var CodeBracketSquareIcon = __webpack_require__(37920);
// EXTERNAL MODULE: ./node_modules/.pnpm/@heroicons+react@2.0.18_react@18.2.0/node_modules/@heroicons/react/24/solid/esm/LanguageIcon.js
var LanguageIcon = __webpack_require__(98620);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-icons+all-files@4.1.0_react@18.2.0/node_modules/@react-icons/all-files/fa/FaBaby.js
var FaBaby = __webpack_require__(45253);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-icons+all-files@4.1.0_react@18.2.0/node_modules/@react-icons/all-files/fa/FaGraduationCap.js
var FaGraduationCap = __webpack_require__(55722);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-icons+all-files@4.1.0_react@18.2.0/node_modules/@react-icons/all-files/si/SiAmazonaws.js
var SiAmazonaws = __webpack_require__(94874);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-icons+all-files@4.1.0_react@18.2.0/node_modules/@react-icons/all-files/si/SiShopify.js
var SiShopify = __webpack_require__(2802);
;// CONCATENATED MODULE: ./content/timeline.tsx






var TIMELINEOBJECT = {
    "2000": [
        {
            date: "2000-08-15",
            heading: "Born",
            description: "In Rio de Janeiro - Brazil",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaBaby/* FaBaby */.x, {
                    className: className
                });
            }
        }, 
    ],
    "2007": [
        {
            date: "2007-05-01",
            heading: "Online",
            description: "My first contact with the internet, I used dial-up internet",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WifiIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2009": [
        {
            date: "2009-07-13",
            heading: "First Computer",
            description: "My first home computer, my father got it from a friend",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerDesktopIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2015": [
        {
            date: "2015-02-03",
            heading: "First line of code",
            description: "My first line of code was developing a plugin for a java minecraft server",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2017": [
        {
            date: "2017-01-01",
            heading: "Graduated High School",
            description: "I finished high school in my hometown",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGraduationCap/* FaGraduationCap */.n, {
                    className: className
                });
            }
        }, 
    ],
    "2018": [
        {
            date: "2018-01-01",
            heading: "Coding Skills",
            description: "I continued to develop my knowledge of programming and did some freelance work",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2019": [
        {
            date: "2019-01-01",
            heading: "Freelance development",
            description: "I developed a bot for twitch and other freelancers for foreigners",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2020": [
        {
            date: "2020-02-01",
            heading: "Computer science degree",
            description: "I started the computer science course at Anhanguera University",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGraduationCap/* FaGraduationCap */.n, {
                    className: className
                });
            }
        },
        {
            date: "2020-09-01",
            heading: "My online game server",
            description: "I set up an online Minecraft server together with friends, with unique systems and using good practices",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerDesktopIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2021": [
        {
            date: "2021-01-01",
            heading: "Freelance development",
            description: "I continued with freelance developments and some personal achievements",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2022": [
        {
            date: "2022-01-01",
            heading: "Freelance development",
            description: "I continued with freelance development",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2022-03-01",
            heading: "Shopify webstore team",
            description: "I was part of the development team for some dropshipping stores on Shopify",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                    className: className
                });
            }
        }, 
    ],
    "2023": [
        {
            date: "2023-05-01",
            heading: "Compasso UOL",
            description: "I was hired by compasso as a backend developer and assigned to the PagBank team",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketSquareIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2023-07-31",
            heading: "Learning English",
            description: "I started to deepen my knowledge of English",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2023-09-09",
            heading: "AWS Certified Cloud Practitioner",
            description: "I managed to get an AWS certification",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiAmazonaws/* SiAmazonaws */.K, {
                    className: className
                });
            }
        }, 
    ]
};

// EXTERNAL MODULE: ./node_modules/.pnpm/framer-motion@7.10.3_react-dom@18.2.0_react@18.2.0/node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(1717);
;// CONCATENATED MODULE: ./components/sections/timeline.tsx









var Timeline = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(""), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react.useState)(false), initiated = ref1[0], setInitiated = ref1[1];
    var scrollContainerRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(true), autoAnimate = ref2[0], setAutoAnimate = ref2[1];
    var ref3 = (0,react.useState)(true), autoScroll = ref3[0], setAutoScroll = ref3[1];
    var inView = (0,use_in_view/* useInView */.Y)(scrollContainerRef);
    (0,react.useEffect)(function() {
        if (!initiated && inView) {
            var container = scrollContainerRef.current;
            setTimeout(function() {
                var year = Object.keys(TIMELINEOBJECT)[0];
                setInitiated(true);
                setSelected("".concat(year, "-", 0));
            }, 50);
        }
    }, [
        inView,
        initiated
    ]);
    useDebouncedEffect(function() {
        var ref;
        if (!autoScroll || !inView) return;
        var ref1 = (0,_sliced_to_array/* default */.Z)(selected.split("-"), 2), year = ref1[0], index = ref1[1];
        var keys = Object.keys(TIMELINEOBJECT);
        var values = Object.values(TIMELINEOBJECT);
        var yearLength = keys.length;
        var yearIndex = keys.findIndex(function(key) {
            return key === year;
        });
        var indexLength = (ref = TIMELINEOBJECT[year]) === null || ref === void 0 ? void 0 : ref.length;
        var totalIndex = values.flat().findIndex(function(val) {
            return new Date(val.date).getFullYear() === +year;
        }) + +index;
        var container = scrollContainerRef.current;
        if (yearIndex + 1 === yearLength && +index + 1 === indexLength) return;
        var scrollTarget = totalIndex * 120;
        if (container.scrollLeft > scrollTarget - 120 || scrollTarget > container.scrollLeft + container.clientWidth - 240) {
            (0,scroll_to/* scrollToX */.T)(200, scrollTarget, container);
        }
        if (+index + 1 !== indexLength) {
            setSelected("".concat(year, "-").concat(+index + 1));
            return;
        }
        if (yearIndex + 1 !== yearLength && +index + 1 === indexLength) {
            setSelected("".concat(keys[yearIndex + 1], "-", 0));
        }
    }, 2400, [
        selected,
        autoScroll,
        inView
    ]);
    useDebouncedEffect(function() {
        setAutoScroll(true);
    }, 10000, [
        autoScroll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "mx-auto max-w-6xl px-4 pb-16 md:px-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "-mx-4 flex h-96 overflow-x-auto py-4 px-6 xl:mx-0",
            ref: scrollContainerRef,
            children: [
                Object.entries(TIMELINEOBJECT).map(function(param, yearIndex, years) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), year = _param[0], events = _param[1];
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                className: "absolute left-0 -translate-x-1/2 select-none text-xs font-semibold text-gray-400",
                                children: year
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6 grid",
                                style: {
                                    gridTemplateColumns: "repeat(".concat(events.length, ", 120px)")
                                },
                                children: events.map(function(param, index) {
                                    var heading = param.heading, Icon = param.Icon, description = param.description;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: (0,clsx_m/* default */.Z)("relative", selected === "".concat(year, "-").concat(index) && "selected"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: " absolute flex -translate-x-1/2 flex-col items-center px-3 hfa:outline-none",
                                                onMouseOver: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                onPointerOver: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                onFocus: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                onClick: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "".concat(year, " - ").concat(heading)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-8 w-0.5 bg-gray-500 transition-all selected:h-[80px] selected:bg-teal-500"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                        className: "mt-2 h-5 w-5 text-gray-500 transition-all d:text-gray-400 selected:text-gray-900 d:selected:text-white"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 left-px h-2.5 w-[119px] bg-[image:linear-gradient(90deg,transparent_0px,transparent_9px,var(--line-color)_10px,var(--line-color)_10px)] bg-[length:10px_10px] [--line-color:theme(colors.gray.500)]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                                className: (0,clsx_m/* default */.Z)("pointer-events-none relative mt-32 w-[17rem] opacity-0 transition-opacity  selected:pointer-events-auto selected:opacity-100", yearIndex === 0 && index === 0 ? "" : "-translate-x-1/2 text-center"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "whitespace-nowrap font-semibold tracking-tight text-gray-800 d:text-gray-100",
                                                        children: heading
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-[15px] font-medium leading-relaxed tracking-tight text-gray-500",
                                                        children: description
                                                    })
                                                ]
                                            })
                                        ]
                                    }, heading);
                                })
                            })
                        ]
                    }, year);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "absolute left-0 -translate-x-1/2 text-xs font-semibold text-gray-400",
                            children: "Today"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-8 w-0.5 bg-gray-500 pb-4"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/party-js@2.2.0/node_modules/party-js/lib/index.js
var lib = __webpack_require__(20691);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./pages/index.tsx






(lib_default()).settings.respectReducedMotion = false;
var Index = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioPreview, {})
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 96316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./prism-abap": [
		57876,
		57876
	],
	"./prism-abap.js": [
		57876,
		57876
	],
	"./prism-abap.min": [
		89849,
		89849
	],
	"./prism-abap.min.js": [
		89849,
		89849
	],
	"./prism-abnf": [
		19300,
		19300
	],
	"./prism-abnf.js": [
		19300,
		19300
	],
	"./prism-abnf.min": [
		29333,
		29333
	],
	"./prism-abnf.min.js": [
		29333,
		29333
	],
	"./prism-actionscript": [
		83182,
		83182
	],
	"./prism-actionscript.js": [
		83182,
		83182
	],
	"./prism-actionscript.min": [
		97033,
		97033
	],
	"./prism-actionscript.min.js": [
		97033,
		97033
	],
	"./prism-ada": [
		29316,
		29316
	],
	"./prism-ada.js": [
		29316,
		29316
	],
	"./prism-ada.min": [
		1125,
		1125
	],
	"./prism-ada.min.js": [
		1125,
		1125
	],
	"./prism-agda": [
		51870,
		51870
	],
	"./prism-agda.js": [
		51870,
		51870
	],
	"./prism-agda.min": [
		27722,
		27722
	],
	"./prism-agda.min.js": [
		27722,
		27722
	],
	"./prism-al": [
		58177,
		58177
	],
	"./prism-al.js": [
		58177,
		58177
	],
	"./prism-al.min": [
		74031,
		74031
	],
	"./prism-al.min.js": [
		74031,
		74031
	],
	"./prism-antlr4": [
		76236,
		76236
	],
	"./prism-antlr4.js": [
		76236,
		76236
	],
	"./prism-antlr4.min": [
		43269,
		43269
	],
	"./prism-antlr4.min.js": [
		43269,
		43269
	],
	"./prism-apacheconf": [
		1949,
		1949
	],
	"./prism-apacheconf.js": [
		1949,
		1949
	],
	"./prism-apacheconf.min": [
		43749,
		43749
	],
	"./prism-apacheconf.min.js": [
		43749,
		43749
	],
	"./prism-apex": [
		28101,
		28101
	],
	"./prism-apex.js": [
		28101,
		28101
	],
	"./prism-apex.min": [
		84846,
		84846
	],
	"./prism-apex.min.js": [
		84846,
		84846
	],
	"./prism-apl": [
		64598,
		64598
	],
	"./prism-apl.js": [
		64598,
		64598
	],
	"./prism-apl.min": [
		69187,
		69187
	],
	"./prism-apl.min.js": [
		69187,
		69187
	],
	"./prism-applescript": [
		34249,
		34249
	],
	"./prism-applescript.js": [
		34249,
		34249
	],
	"./prism-applescript.min": [
		83525,
		83525
	],
	"./prism-applescript.min.js": [
		83525,
		83525
	],
	"./prism-aql": [
		94041,
		94041
	],
	"./prism-aql.js": [
		94041,
		94041
	],
	"./prism-aql.min": [
		74243,
		74243
	],
	"./prism-aql.min.js": [
		74243,
		74243
	],
	"./prism-arduino": [
		32224,
		32224
	],
	"./prism-arduino.js": [
		32224,
		32224
	],
	"./prism-arduino.min": [
		17451,
		17451
	],
	"./prism-arduino.min.js": [
		17451,
		17451
	],
	"./prism-arff": [
		36224,
		36224
	],
	"./prism-arff.js": [
		36224,
		36224
	],
	"./prism-arff.min": [
		66193,
		66193
	],
	"./prism-arff.min.js": [
		66193,
		66193
	],
	"./prism-armasm": [
		4796,
		4796
	],
	"./prism-armasm.js": [
		4796,
		4796
	],
	"./prism-armasm.min": [
		5224,
		5224
	],
	"./prism-armasm.min.js": [
		5224,
		5224
	],
	"./prism-arturo": [
		16161,
		16161
	],
	"./prism-arturo.js": [
		16161,
		16161
	],
	"./prism-arturo.min": [
		13975,
		13975
	],
	"./prism-arturo.min.js": [
		13975,
		13975
	],
	"./prism-asciidoc": [
		79909,
		79909
	],
	"./prism-asciidoc.js": [
		79909,
		79909
	],
	"./prism-asciidoc.min": [
		78367,
		78367
	],
	"./prism-asciidoc.min.js": [
		78367,
		78367
	],
	"./prism-asm6502": [
		18623,
		18623
	],
	"./prism-asm6502.js": [
		18623,
		18623
	],
	"./prism-asm6502.min": [
		15347,
		15347
	],
	"./prism-asm6502.min.js": [
		15347,
		15347
	],
	"./prism-asmatmel": [
		18419,
		18419
	],
	"./prism-asmatmel.js": [
		18419,
		18419
	],
	"./prism-asmatmel.min": [
		15639,
		15639
	],
	"./prism-asmatmel.min.js": [
		15639,
		15639
	],
	"./prism-aspnet": [
		73418,
		73418
	],
	"./prism-aspnet.js": [
		73418,
		73418
	],
	"./prism-aspnet.min": [
		3301,
		3301
	],
	"./prism-aspnet.min.js": [
		3301,
		3301
	],
	"./prism-autohotkey": [
		38281,
		38281
	],
	"./prism-autohotkey.js": [
		38281,
		38281
	],
	"./prism-autohotkey.min": [
		71902,
		71902
	],
	"./prism-autohotkey.min.js": [
		71902,
		71902
	],
	"./prism-autoit": [
		74247,
		74247
	],
	"./prism-autoit.js": [
		74247,
		74247
	],
	"./prism-autoit.min": [
		18682,
		18682
	],
	"./prism-autoit.min.js": [
		18682,
		18682
	],
	"./prism-avisynth": [
		49173,
		49173
	],
	"./prism-avisynth.js": [
		49173,
		49173
	],
	"./prism-avisynth.min": [
		41594,
		41594
	],
	"./prism-avisynth.min.js": [
		41594,
		41594
	],
	"./prism-avro-idl": [
		49208,
		49208
	],
	"./prism-avro-idl.js": [
		49208,
		49208
	],
	"./prism-avro-idl.min": [
		2342,
		2342
	],
	"./prism-avro-idl.min.js": [
		2342,
		2342
	],
	"./prism-awk": [
		22698,
		22698
	],
	"./prism-awk.js": [
		22698,
		22698
	],
	"./prism-awk.min": [
		94709,
		94709
	],
	"./prism-awk.min.js": [
		94709,
		94709
	],
	"./prism-bash": [
		3209,
		3209
	],
	"./prism-bash.js": [
		3209,
		3209
	],
	"./prism-bash.min": [
		3745,
		3745
	],
	"./prism-bash.min.js": [
		3745,
		3745
	],
	"./prism-basic": [
		82959,
		82959
	],
	"./prism-basic.js": [
		82959,
		82959
	],
	"./prism-basic.min": [
		90039,
		90039
	],
	"./prism-basic.min.js": [
		90039,
		90039
	],
	"./prism-batch": [
		3946,
		3946
	],
	"./prism-batch.js": [
		3946,
		3946
	],
	"./prism-batch.min": [
		43820,
		43820
	],
	"./prism-batch.min.js": [
		43820,
		43820
	],
	"./prism-bbcode": [
		25246,
		25246
	],
	"./prism-bbcode.js": [
		25246,
		25246
	],
	"./prism-bbcode.min": [
		89307,
		89307
	],
	"./prism-bbcode.min.js": [
		89307,
		89307
	],
	"./prism-bbj": [
		2066,
		2066
	],
	"./prism-bbj.js": [
		2066,
		2066
	],
	"./prism-bbj.min": [
		5353,
		5353
	],
	"./prism-bbj.min.js": [
		5353,
		5353
	],
	"./prism-bicep": [
		50901,
		50901
	],
	"./prism-bicep.js": [
		50901,
		50901
	],
	"./prism-bicep.min": [
		54377,
		54377
	],
	"./prism-bicep.min.js": [
		54377,
		54377
	],
	"./prism-birb": [
		3277,
		3277
	],
	"./prism-birb.js": [
		3277,
		3277
	],
	"./prism-birb.min": [
		84720,
		84720
	],
	"./prism-birb.min.js": [
		84720,
		84720
	],
	"./prism-bison": [
		7581,
		7581
	],
	"./prism-bison.js": [
		7581,
		7581
	],
	"./prism-bison.min": [
		59019,
		59019
	],
	"./prism-bison.min.js": [
		59019,
		59019
	],
	"./prism-bnf": [
		25090,
		25090
	],
	"./prism-bnf.js": [
		25090,
		25090
	],
	"./prism-bnf.min": [
		36816,
		36816
	],
	"./prism-bnf.min.js": [
		36816,
		36816
	],
	"./prism-bqn": [
		89220,
		89220
	],
	"./prism-bqn.js": [
		89220,
		89220
	],
	"./prism-bqn.min": [
		35180,
		35180
	],
	"./prism-bqn.min.js": [
		35180,
		35180
	],
	"./prism-brainfuck": [
		56234,
		56234
	],
	"./prism-brainfuck.js": [
		56234,
		56234
	],
	"./prism-brainfuck.min": [
		52896,
		52896
	],
	"./prism-brainfuck.min.js": [
		52896,
		52896
	],
	"./prism-brightscript": [
		44869,
		44869
	],
	"./prism-brightscript.js": [
		44869,
		44869
	],
	"./prism-brightscript.min": [
		97798,
		97798
	],
	"./prism-brightscript.min.js": [
		97798,
		97798
	],
	"./prism-bro": [
		46400,
		46400
	],
	"./prism-bro.js": [
		46400,
		46400
	],
	"./prism-bro.min": [
		68222,
		68222
	],
	"./prism-bro.min.js": [
		68222,
		68222
	],
	"./prism-bsl": [
		76166,
		76166
	],
	"./prism-bsl.js": [
		76166,
		76166
	],
	"./prism-bsl.min": [
		31352,
		31352
	],
	"./prism-bsl.min.js": [
		31352,
		31352
	],
	"./prism-c": [
		50497,
		50497
	],
	"./prism-c.js": [
		50497,
		50497
	],
	"./prism-c.min": [
		65775,
		65775
	],
	"./prism-c.min.js": [
		65775,
		65775
	],
	"./prism-cfscript": [
		47080,
		47080
	],
	"./prism-cfscript.js": [
		47080,
		47080
	],
	"./prism-cfscript.min": [
		38051,
		38051
	],
	"./prism-cfscript.min.js": [
		38051,
		38051
	],
	"./prism-chaiscript": [
		35314,
		35314
	],
	"./prism-chaiscript.js": [
		35314,
		35314
	],
	"./prism-chaiscript.min": [
		6841,
		6841
	],
	"./prism-chaiscript.min.js": [
		6841,
		6841
	],
	"./prism-cil": [
		39220,
		39220
	],
	"./prism-cil.js": [
		39220,
		39220
	],
	"./prism-cil.min": [
		83397,
		83397
	],
	"./prism-cil.min.js": [
		83397,
		83397
	],
	"./prism-cilkc": [
		71332,
		71332
	],
	"./prism-cilkc.js": [
		71332,
		71332
	],
	"./prism-cilkc.min": [
		34802,
		34802
	],
	"./prism-cilkc.min.js": [
		34802,
		34802
	],
	"./prism-cilkcpp": [
		23169,
		23169
	],
	"./prism-cilkcpp.js": [
		23169,
		23169
	],
	"./prism-cilkcpp.min": [
		37303,
		37303
	],
	"./prism-cilkcpp.min.js": [
		37303,
		37303
	],
	"./prism-clike": [
		55308,
		55308
	],
	"./prism-clike.js": [
		55308,
		55308
	],
	"./prism-clike.min": [
		21997,
		21997
	],
	"./prism-clike.min.js": [
		21997,
		21997
	],
	"./prism-clojure": [
		41116,
		41116
	],
	"./prism-clojure.js": [
		41116,
		41116
	],
	"./prism-clojure.min": [
		34499,
		34499
	],
	"./prism-clojure.min.js": [
		34499,
		34499
	],
	"./prism-cmake": [
		4401,
		4401
	],
	"./prism-cmake.js": [
		4401,
		4401
	],
	"./prism-cmake.min": [
		44012,
		44012
	],
	"./prism-cmake.min.js": [
		44012,
		44012
	],
	"./prism-cobol": [
		80794,
		80794
	],
	"./prism-cobol.js": [
		80794,
		80794
	],
	"./prism-cobol.min": [
		1561,
		1561
	],
	"./prism-cobol.min.js": [
		1561,
		1561
	],
	"./prism-coffeescript": [
		45944,
		45944
	],
	"./prism-coffeescript.js": [
		45944,
		45944
	],
	"./prism-coffeescript.min": [
		66241,
		66241
	],
	"./prism-coffeescript.min.js": [
		66241,
		66241
	],
	"./prism-concurnas": [
		24030,
		24030
	],
	"./prism-concurnas.js": [
		24030,
		24030
	],
	"./prism-concurnas.min": [
		57311,
		57311
	],
	"./prism-concurnas.min.js": [
		57311,
		57311
	],
	"./prism-cooklang": [
		72725,
		72725
	],
	"./prism-cooklang.js": [
		72725,
		72725
	],
	"./prism-cooklang.min": [
		90740,
		90740
	],
	"./prism-cooklang.min.js": [
		90740,
		90740
	],
	"./prism-coq": [
		24853,
		24853
	],
	"./prism-coq.js": [
		24853,
		24853
	],
	"./prism-coq.min": [
		45069,
		45069
	],
	"./prism-coq.min.js": [
		45069,
		45069
	],
	"./prism-core": [
		17834,
		17834
	],
	"./prism-core.js": [
		17834,
		17834
	],
	"./prism-core.min": [
		30825,
		30825
	],
	"./prism-core.min.js": [
		30825,
		30825
	],
	"./prism-cpp": [
		86364,
		86364
	],
	"./prism-cpp.js": [
		86364,
		86364
	],
	"./prism-cpp.min": [
		28467,
		28467
	],
	"./prism-cpp.min.js": [
		28467,
		28467
	],
	"./prism-crystal": [
		81688,
		81688
	],
	"./prism-crystal.js": [
		81688,
		81688
	],
	"./prism-crystal.min": [
		21186,
		21186
	],
	"./prism-crystal.min.js": [
		21186,
		21186
	],
	"./prism-csharp": [
		56178,
		56178
	],
	"./prism-csharp.js": [
		56178,
		56178
	],
	"./prism-csharp.min": [
		30095,
		30095
	],
	"./prism-csharp.min.js": [
		30095,
		30095
	],
	"./prism-cshtml": [
		5434,
		5434
	],
	"./prism-cshtml.js": [
		5434,
		5434
	],
	"./prism-cshtml.min": [
		91862,
		91862
	],
	"./prism-cshtml.min.js": [
		91862,
		91862
	],
	"./prism-csp": [
		5107,
		5107
	],
	"./prism-csp.js": [
		5107,
		5107
	],
	"./prism-csp.min": [
		34279,
		34279
	],
	"./prism-csp.min.js": [
		34279,
		34279
	],
	"./prism-css": [
		93063,
		93063
	],
	"./prism-css-extras": [
		92971,
		92971
	],
	"./prism-css-extras.js": [
		92971,
		92971
	],
	"./prism-css-extras.min": [
		40811,
		40811
	],
	"./prism-css-extras.min.js": [
		40811,
		40811
	],
	"./prism-css.js": [
		93063,
		93063
	],
	"./prism-css.min": [
		54683,
		54683
	],
	"./prism-css.min.js": [
		54683,
		54683
	],
	"./prism-csv": [
		61118,
		61118
	],
	"./prism-csv.js": [
		61118,
		61118
	],
	"./prism-csv.min": [
		77434,
		77434
	],
	"./prism-csv.min.js": [
		77434,
		77434
	],
	"./prism-cue": [
		83968,
		83968
	],
	"./prism-cue.js": [
		83968,
		83968
	],
	"./prism-cue.min": [
		42205,
		42205
	],
	"./prism-cue.min.js": [
		42205,
		42205
	],
	"./prism-cypher": [
		54034,
		54034
	],
	"./prism-cypher.js": [
		54034,
		54034
	],
	"./prism-cypher.min": [
		51589,
		51589
	],
	"./prism-cypher.min.js": [
		51589,
		51589
	],
	"./prism-d": [
		61122,
		61122
	],
	"./prism-d.js": [
		61122,
		61122
	],
	"./prism-d.min": [
		96699,
		96699
	],
	"./prism-d.min.js": [
		96699,
		96699
	],
	"./prism-dart": [
		41707,
		41707
	],
	"./prism-dart.js": [
		41707,
		41707
	],
	"./prism-dart.min": [
		58930,
		58930
	],
	"./prism-dart.min.js": [
		58930,
		58930
	],
	"./prism-dataweave": [
		93790,
		93790
	],
	"./prism-dataweave.js": [
		93790,
		93790
	],
	"./prism-dataweave.min": [
		3402,
		3402
	],
	"./prism-dataweave.min.js": [
		3402,
		3402
	],
	"./prism-dax": [
		68161,
		68161
	],
	"./prism-dax.js": [
		68161,
		68161
	],
	"./prism-dax.min": [
		19672,
		19672
	],
	"./prism-dax.min.js": [
		19672,
		19672
	],
	"./prism-dhall": [
		33018,
		33018
	],
	"./prism-dhall.js": [
		33018,
		33018
	],
	"./prism-dhall.min": [
		92536,
		92536
	],
	"./prism-dhall.min.js": [
		92536,
		92536
	],
	"./prism-diff": [
		93931,
		93931
	],
	"./prism-diff.js": [
		93931,
		93931
	],
	"./prism-diff.min": [
		88486,
		88486
	],
	"./prism-diff.min.js": [
		88486,
		88486
	],
	"./prism-django": [
		5627,
		5627
	],
	"./prism-django.js": [
		5627,
		5627
	],
	"./prism-django.min": [
		31322,
		31322
	],
	"./prism-django.min.js": [
		31322,
		31322
	],
	"./prism-dns-zone-file": [
		75624,
		75624
	],
	"./prism-dns-zone-file.js": [
		75624,
		75624
	],
	"./prism-dns-zone-file.min": [
		7480,
		7480
	],
	"./prism-dns-zone-file.min.js": [
		7480,
		7480
	],
	"./prism-docker": [
		25495,
		25495
	],
	"./prism-docker.js": [
		25495,
		25495
	],
	"./prism-docker.min": [
		6514,
		6514
	],
	"./prism-docker.min.js": [
		6514,
		6514
	],
	"./prism-dot": [
		71991,
		71991
	],
	"./prism-dot.js": [
		71991,
		71991
	],
	"./prism-dot.min": [
		64860,
		64860
	],
	"./prism-dot.min.js": [
		64860,
		64860
	],
	"./prism-ebnf": [
		88250,
		88250
	],
	"./prism-ebnf.js": [
		88250,
		88250
	],
	"./prism-ebnf.min": [
		64333,
		64333
	],
	"./prism-ebnf.min.js": [
		64333,
		64333
	],
	"./prism-editorconfig": [
		64352,
		64352
	],
	"./prism-editorconfig.js": [
		64352,
		64352
	],
	"./prism-editorconfig.min": [
		63532,
		63532
	],
	"./prism-editorconfig.min.js": [
		63532,
		63532
	],
	"./prism-eiffel": [
		77346,
		77346
	],
	"./prism-eiffel.js": [
		77346,
		77346
	],
	"./prism-eiffel.min": [
		2170,
		2170
	],
	"./prism-eiffel.min.js": [
		2170,
		2170
	],
	"./prism-ejs": [
		88684,
		88684
	],
	"./prism-ejs.js": [
		88684,
		88684
	],
	"./prism-ejs.min": [
		88528,
		88528
	],
	"./prism-ejs.min.js": [
		88528,
		88528
	],
	"./prism-elixir": [
		26930,
		26930
	],
	"./prism-elixir.js": [
		26930,
		26930
	],
	"./prism-elixir.min": [
		94930,
		94930
	],
	"./prism-elixir.min.js": [
		94930,
		94930
	],
	"./prism-elm": [
		57972,
		57972
	],
	"./prism-elm.js": [
		57972,
		57972
	],
	"./prism-elm.min": [
		90556,
		90556
	],
	"./prism-elm.min.js": [
		90556,
		90556
	],
	"./prism-erb": [
		82151,
		82151
	],
	"./prism-erb.js": [
		82151,
		82151
	],
	"./prism-erb.min": [
		58240,
		58240
	],
	"./prism-erb.min.js": [
		58240,
		58240
	],
	"./prism-erlang": [
		5558,
		5558
	],
	"./prism-erlang.js": [
		5558,
		5558
	],
	"./prism-erlang.min": [
		49430,
		49430
	],
	"./prism-erlang.min.js": [
		49430,
		49430
	],
	"./prism-etlua": [
		15540,
		15540
	],
	"./prism-etlua.js": [
		15540,
		15540
	],
	"./prism-etlua.min": [
		37390,
		37390
	],
	"./prism-etlua.min.js": [
		37390,
		37390
	],
	"./prism-excel-formula": [
		90345,
		90345
	],
	"./prism-excel-formula.js": [
		90345,
		90345
	],
	"./prism-excel-formula.min": [
		779,
		779
	],
	"./prism-excel-formula.min.js": [
		779,
		779
	],
	"./prism-factor": [
		99538,
		99538
	],
	"./prism-factor.js": [
		99538,
		99538
	],
	"./prism-factor.min": [
		52443,
		52443
	],
	"./prism-factor.min.js": [
		52443,
		52443
	],
	"./prism-false": [
		32578,
		32578
	],
	"./prism-false.js": [
		32578,
		32578
	],
	"./prism-false.min": [
		60984,
		60984
	],
	"./prism-false.min.js": [
		60984,
		60984
	],
	"./prism-firestore-security-rules": [
		64412,
		64412
	],
	"./prism-firestore-security-rules.js": [
		64412,
		64412
	],
	"./prism-firestore-security-rules.min": [
		67958,
		67958
	],
	"./prism-firestore-security-rules.min.js": [
		67958,
		67958
	],
	"./prism-flow": [
		12509,
		12509
	],
	"./prism-flow.js": [
		12509,
		12509
	],
	"./prism-flow.min": [
		95626,
		95626
	],
	"./prism-flow.min.js": [
		95626,
		95626
	],
	"./prism-fortran": [
		52516,
		52516
	],
	"./prism-fortran.js": [
		52516,
		52516
	],
	"./prism-fortran.min": [
		29304,
		29304
	],
	"./prism-fortran.min.js": [
		29304,
		29304
	],
	"./prism-fsharp": [
		35287,
		35287
	],
	"./prism-fsharp.js": [
		35287,
		35287
	],
	"./prism-fsharp.min": [
		69419,
		69419
	],
	"./prism-fsharp.min.js": [
		69419,
		69419
	],
	"./prism-ftl": [
		53930,
		53930
	],
	"./prism-ftl.js": [
		53930,
		53930
	],
	"./prism-ftl.min": [
		46171,
		46171
	],
	"./prism-ftl.min.js": [
		46171,
		46171
	],
	"./prism-gap": [
		79729,
		79729
	],
	"./prism-gap.js": [
		79729,
		79729
	],
	"./prism-gap.min": [
		8111,
		8111
	],
	"./prism-gap.min.js": [
		8111,
		8111
	],
	"./prism-gcode": [
		83830,
		83830
	],
	"./prism-gcode.js": [
		83830,
		83830
	],
	"./prism-gcode.min": [
		51722,
		51722
	],
	"./prism-gcode.min.js": [
		51722,
		51722
	],
	"./prism-gdscript": [
		24093,
		24093
	],
	"./prism-gdscript.js": [
		24093,
		24093
	],
	"./prism-gdscript.min": [
		27936,
		27936
	],
	"./prism-gdscript.min.js": [
		27936,
		27936
	],
	"./prism-gedcom": [
		72043,
		72043
	],
	"./prism-gedcom.js": [
		72043,
		72043
	],
	"./prism-gedcom.min": [
		48238,
		48238
	],
	"./prism-gedcom.min.js": [
		48238,
		48238
	],
	"./prism-gettext": [
		54525,
		54525
	],
	"./prism-gettext.js": [
		54525,
		54525
	],
	"./prism-gettext.min": [
		69198,
		69198
	],
	"./prism-gettext.min.js": [
		69198,
		69198
	],
	"./prism-gherkin": [
		44589,
		44589
	],
	"./prism-gherkin.js": [
		44589,
		44589
	],
	"./prism-gherkin.min": [
		97161,
		97161
	],
	"./prism-gherkin.min.js": [
		97161,
		97161
	],
	"./prism-git": [
		55267,
		55267
	],
	"./prism-git.js": [
		55267,
		55267
	],
	"./prism-git.min": [
		25105,
		25105
	],
	"./prism-git.min.js": [
		25105,
		25105
	],
	"./prism-glsl": [
		15232,
		85858
	],
	"./prism-glsl.js": [
		15232,
		85858
	],
	"./prism-glsl.min": [
		36595,
		36595
	],
	"./prism-glsl.min.js": [
		36595,
		36595
	],
	"./prism-gml": [
		79799,
		79799
	],
	"./prism-gml.js": [
		79799,
		79799
	],
	"./prism-gml.min": [
		81838,
		81838
	],
	"./prism-gml.min.js": [
		81838,
		81838
	],
	"./prism-gn": [
		23235,
		23235
	],
	"./prism-gn.js": [
		23235,
		23235
	],
	"./prism-gn.min": [
		87159,
		87159
	],
	"./prism-gn.min.js": [
		87159,
		87159
	],
	"./prism-go": [
		63492,
		63492
	],
	"./prism-go-module": [
		15276,
		15276
	],
	"./prism-go-module.js": [
		15276,
		15276
	],
	"./prism-go-module.min": [
		34585,
		34585
	],
	"./prism-go-module.min.js": [
		34585,
		34585
	],
	"./prism-go.js": [
		63492,
		63492
	],
	"./prism-go.min": [
		26290,
		26290
	],
	"./prism-go.min.js": [
		26290,
		26290
	],
	"./prism-gradle": [
		52436,
		52436
	],
	"./prism-gradle.js": [
		52436,
		52436
	],
	"./prism-gradle.min": [
		49265,
		49265
	],
	"./prism-gradle.min.js": [
		49265,
		49265
	],
	"./prism-graphql": [
		14989,
		14989
	],
	"./prism-graphql.js": [
		14989,
		14989
	],
	"./prism-graphql.min": [
		73473,
		73473
	],
	"./prism-graphql.min.js": [
		73473,
		73473
	],
	"./prism-groovy": [
		91199,
		48018
	],
	"./prism-groovy.js": [
		91199,
		48018
	],
	"./prism-groovy.min": [
		22537,
		22537
	],
	"./prism-groovy.min.js": [
		22537,
		22537
	],
	"./prism-haml": [
		51441,
		51441
	],
	"./prism-haml.js": [
		51441,
		51441
	],
	"./prism-haml.min": [
		62458,
		62458
	],
	"./prism-haml.min.js": [
		62458,
		62458
	],
	"./prism-handlebars": [
		18810,
		18810
	],
	"./prism-handlebars.js": [
		18810,
		18810
	],
	"./prism-handlebars.min": [
		34555,
		34555
	],
	"./prism-handlebars.min.js": [
		34555,
		34555
	],
	"./prism-haskell": [
		50444,
		50444
	],
	"./prism-haskell.js": [
		50444,
		50444
	],
	"./prism-haskell.min": [
		96470,
		96470
	],
	"./prism-haskell.min.js": [
		96470,
		96470
	],
	"./prism-haxe": [
		68615,
		68615
	],
	"./prism-haxe.js": [
		68615,
		68615
	],
	"./prism-haxe.min": [
		65917,
		65917
	],
	"./prism-haxe.min.js": [
		65917,
		65917
	],
	"./prism-hcl": [
		7465,
		7465
	],
	"./prism-hcl.js": [
		7465,
		7465
	],
	"./prism-hcl.min": [
		32024,
		32024
	],
	"./prism-hcl.min.js": [
		32024,
		32024
	],
	"./prism-hlsl": [
		88753,
		88753
	],
	"./prism-hlsl.js": [
		88753,
		88753
	],
	"./prism-hlsl.min": [
		44958,
		44958
	],
	"./prism-hlsl.min.js": [
		44958,
		44958
	],
	"./prism-hoon": [
		52915,
		52915
	],
	"./prism-hoon.js": [
		52915,
		52915
	],
	"./prism-hoon.min": [
		79522,
		79522
	],
	"./prism-hoon.min.js": [
		79522,
		79522
	],
	"./prism-hpkp": [
		13542,
		13542
	],
	"./prism-hpkp.js": [
		13542,
		13542
	],
	"./prism-hpkp.min": [
		50591,
		50591
	],
	"./prism-hpkp.min.js": [
		50591,
		50591
	],
	"./prism-hsts": [
		26151,
		26151
	],
	"./prism-hsts.js": [
		26151,
		26151
	],
	"./prism-hsts.min": [
		36463,
		36463
	],
	"./prism-hsts.min.js": [
		36463,
		36463
	],
	"./prism-http": [
		78546,
		78546
	],
	"./prism-http.js": [
		78546,
		78546
	],
	"./prism-http.min": [
		66878,
		66878
	],
	"./prism-http.min.js": [
		66878,
		66878
	],
	"./prism-ichigojam": [
		83470,
		83470
	],
	"./prism-ichigojam.js": [
		83470,
		83470
	],
	"./prism-ichigojam.min": [
		95895,
		95895
	],
	"./prism-ichigojam.min.js": [
		95895,
		95895
	],
	"./prism-icon": [
		82101,
		82101
	],
	"./prism-icon.js": [
		82101,
		82101
	],
	"./prism-icon.min": [
		77442,
		77442
	],
	"./prism-icon.min.js": [
		77442,
		77442
	],
	"./prism-icu-message-format": [
		74891,
		74891
	],
	"./prism-icu-message-format.js": [
		74891,
		74891
	],
	"./prism-icu-message-format.min": [
		13477,
		13477
	],
	"./prism-icu-message-format.min.js": [
		13477,
		13477
	],
	"./prism-idris": [
		91903,
		91903
	],
	"./prism-idris.js": [
		91903,
		91903
	],
	"./prism-idris.min": [
		47639,
		47639
	],
	"./prism-idris.min.js": [
		47639,
		47639
	],
	"./prism-iecst": [
		44592,
		44592
	],
	"./prism-iecst.js": [
		44592,
		44592
	],
	"./prism-iecst.min": [
		66676,
		66676
	],
	"./prism-iecst.min.js": [
		66676,
		66676
	],
	"./prism-ignore": [
		1638,
		1638
	],
	"./prism-ignore.js": [
		1638,
		1638
	],
	"./prism-ignore.min": [
		14856,
		14856
	],
	"./prism-ignore.min.js": [
		14856,
		14856
	],
	"./prism-inform7": [
		17952,
		17952
	],
	"./prism-inform7.js": [
		17952,
		17952
	],
	"./prism-inform7.min": [
		37877,
		37877
	],
	"./prism-inform7.min.js": [
		37877,
		37877
	],
	"./prism-ini": [
		47900,
		47900
	],
	"./prism-ini.js": [
		47900,
		47900
	],
	"./prism-ini.min": [
		68585,
		68585
	],
	"./prism-ini.min.js": [
		68585,
		68585
	],
	"./prism-io": [
		76342,
		76342
	],
	"./prism-io.js": [
		76342,
		76342
	],
	"./prism-io.min": [
		8812,
		8812
	],
	"./prism-io.min.js": [
		8812,
		8812
	],
	"./prism-j": [
		91929,
		91929
	],
	"./prism-j.js": [
		91929,
		91929
	],
	"./prism-j.min": [
		36602,
		36602
	],
	"./prism-j.min.js": [
		36602,
		36602
	],
	"./prism-java": [
		50955,
		50955
	],
	"./prism-java.js": [
		50955,
		50955
	],
	"./prism-java.min": [
		18751,
		18751
	],
	"./prism-java.min.js": [
		18751,
		18751
	],
	"./prism-javadoc": [
		8210,
		8210
	],
	"./prism-javadoc.js": [
		8210,
		8210
	],
	"./prism-javadoc.min": [
		71846,
		71846
	],
	"./prism-javadoc.min.js": [
		71846,
		71846
	],
	"./prism-javadoclike": [
		32527,
		32527
	],
	"./prism-javadoclike.js": [
		32527,
		32527
	],
	"./prism-javadoclike.min": [
		32589,
		32589
	],
	"./prism-javadoclike.min.js": [
		32589,
		32589
	],
	"./prism-javascript": [
		64326,
		64326
	],
	"./prism-javascript.js": [
		64326,
		64326
	],
	"./prism-javascript.min": [
		42454,
		42454
	],
	"./prism-javascript.min.js": [
		42454,
		42454
	],
	"./prism-javastacktrace": [
		79172,
		79172
	],
	"./prism-javastacktrace.js": [
		79172,
		79172
	],
	"./prism-javastacktrace.min": [
		17824,
		17824
	],
	"./prism-javastacktrace.min.js": [
		17824,
		17824
	],
	"./prism-jexl": [
		57604,
		57604
	],
	"./prism-jexl.js": [
		57604,
		57604
	],
	"./prism-jexl.min": [
		89135,
		89135
	],
	"./prism-jexl.min.js": [
		89135,
		89135
	],
	"./prism-jolie": [
		20192,
		20192
	],
	"./prism-jolie.js": [
		20192,
		20192
	],
	"./prism-jolie.min": [
		76970,
		76970
	],
	"./prism-jolie.min.js": [
		76970,
		76970
	],
	"./prism-jq": [
		82142,
		82142
	],
	"./prism-jq.js": [
		82142,
		82142
	],
	"./prism-jq.min": [
		75685,
		75685
	],
	"./prism-jq.min.js": [
		75685,
		75685
	],
	"./prism-js-extras": [
		5018,
		5018
	],
	"./prism-js-extras.js": [
		5018,
		5018
	],
	"./prism-js-extras.min": [
		61388,
		91199
	],
	"./prism-js-extras.min.js": [
		61388,
		91199
	],
	"./prism-js-templates": [
		46781,
		46781
	],
	"./prism-js-templates.js": [
		46781,
		46781
	],
	"./prism-js-templates.min": [
		99905,
		99905
	],
	"./prism-js-templates.min.js": [
		99905,
		99905
	],
	"./prism-jsdoc": [
		9510,
		15232
	],
	"./prism-jsdoc.js": [
		9510,
		15232
	],
	"./prism-jsdoc.min": [
		53697,
		53697
	],
	"./prism-jsdoc.min.js": [
		53697,
		53697
	],
	"./prism-json": [
		21417,
		21417
	],
	"./prism-json.js": [
		21417,
		21417
	],
	"./prism-json.min": [
		75256,
		75256
	],
	"./prism-json.min.js": [
		75256,
		75256
	],
	"./prism-json5": [
		71567,
		71567
	],
	"./prism-json5.js": [
		71567,
		71567
	],
	"./prism-json5.min": [
		6444,
		6444
	],
	"./prism-json5.min.js": [
		6444,
		6444
	],
	"./prism-jsonp": [
		54348,
		54348
	],
	"./prism-jsonp.js": [
		54348,
		54348
	],
	"./prism-jsonp.min": [
		49078,
		49078
	],
	"./prism-jsonp.min.js": [
		49078,
		49078
	],
	"./prism-jsstacktrace": [
		73152,
		73152
	],
	"./prism-jsstacktrace.js": [
		73152,
		73152
	],
	"./prism-jsstacktrace.min": [
		25874,
		25874
	],
	"./prism-jsstacktrace.min.js": [
		25874,
		25874
	],
	"./prism-jsx": [
		88257,
		88257
	],
	"./prism-jsx.js": [
		88257,
		88257
	],
	"./prism-jsx.min": [
		59819,
		59819
	],
	"./prism-jsx.min.js": [
		59819,
		59819
	],
	"./prism-julia": [
		32769,
		32769
	],
	"./prism-julia.js": [
		32769,
		32769
	],
	"./prism-julia.min": [
		40981,
		40981
	],
	"./prism-julia.min.js": [
		40981,
		40981
	],
	"./prism-keepalived": [
		76551,
		76551
	],
	"./prism-keepalived.js": [
		76551,
		76551
	],
	"./prism-keepalived.min": [
		36662,
		36662
	],
	"./prism-keepalived.min.js": [
		36662,
		36662
	],
	"./prism-keyman": [
		98319,
		98319
	],
	"./prism-keyman.js": [
		98319,
		98319
	],
	"./prism-keyman.min": [
		2197,
		2197
	],
	"./prism-keyman.min.js": [
		2197,
		2197
	],
	"./prism-kotlin": [
		81798,
		81798
	],
	"./prism-kotlin.js": [
		81798,
		81798
	],
	"./prism-kotlin.min": [
		44575,
		44575
	],
	"./prism-kotlin.min.js": [
		44575,
		44575
	],
	"./prism-kumir": [
		81904,
		81904
	],
	"./prism-kumir.js": [
		81904,
		81904
	],
	"./prism-kumir.min": [
		84845,
		84845
	],
	"./prism-kumir.min.js": [
		84845,
		84845
	],
	"./prism-kusto": [
		39924,
		39924
	],
	"./prism-kusto.js": [
		39924,
		39924
	],
	"./prism-kusto.min": [
		20492,
		20492
	],
	"./prism-kusto.min.js": [
		20492,
		20492
	],
	"./prism-latex": [
		17017,
		17017
	],
	"./prism-latex.js": [
		17017,
		17017
	],
	"./prism-latex.min": [
		12835,
		12835
	],
	"./prism-latex.min.js": [
		12835,
		12835
	],
	"./prism-latte": [
		81326,
		81326
	],
	"./prism-latte.js": [
		81326,
		81326
	],
	"./prism-latte.min": [
		66561,
		66561
	],
	"./prism-latte.min.js": [
		66561,
		66561
	],
	"./prism-less": [
		11601,
		11601
	],
	"./prism-less.js": [
		11601,
		11601
	],
	"./prism-less.min": [
		56580,
		56580
	],
	"./prism-less.min.js": [
		56580,
		56580
	],
	"./prism-lilypond": [
		19033,
		19033
	],
	"./prism-lilypond.js": [
		19033,
		19033
	],
	"./prism-lilypond.min": [
		5258,
		5258
	],
	"./prism-lilypond.min.js": [
		5258,
		5258
	],
	"./prism-linker-script": [
		71874,
		71874
	],
	"./prism-linker-script.js": [
		71874,
		71874
	],
	"./prism-linker-script.min": [
		1156,
		1156
	],
	"./prism-linker-script.min.js": [
		1156,
		1156
	],
	"./prism-liquid": [
		86989,
		86989
	],
	"./prism-liquid.js": [
		86989,
		86989
	],
	"./prism-liquid.min": [
		51999,
		51999
	],
	"./prism-liquid.min.js": [
		51999,
		51999
	],
	"./prism-lisp": [
		90174,
		90174
	],
	"./prism-lisp.js": [
		90174,
		90174
	],
	"./prism-lisp.min": [
		15472,
		15472
	],
	"./prism-lisp.min.js": [
		15472,
		15472
	],
	"./prism-livescript": [
		34437,
		34437
	],
	"./prism-livescript.js": [
		34437,
		34437
	],
	"./prism-livescript.min": [
		30218,
		30218
	],
	"./prism-livescript.min.js": [
		30218,
		30218
	],
	"./prism-llvm": [
		55031,
		55031
	],
	"./prism-llvm.js": [
		55031,
		55031
	],
	"./prism-llvm.min": [
		93566,
		93566
	],
	"./prism-llvm.min.js": [
		93566,
		93566
	],
	"./prism-log": [
		22385,
		22385
	],
	"./prism-log.js": [
		22385,
		22385
	],
	"./prism-log.min": [
		69453,
		69453
	],
	"./prism-log.min.js": [
		69453,
		69453
	],
	"./prism-lolcode": [
		18305,
		18305
	],
	"./prism-lolcode.js": [
		18305,
		18305
	],
	"./prism-lolcode.min": [
		65157,
		65157
	],
	"./prism-lolcode.min.js": [
		65157,
		65157
	],
	"./prism-lua": [
		60505,
		60505
	],
	"./prism-lua.js": [
		60505,
		60505
	],
	"./prism-lua.min": [
		49531,
		49531
	],
	"./prism-lua.min.js": [
		49531,
		49531
	],
	"./prism-magma": [
		70410,
		70410
	],
	"./prism-magma.js": [
		70410,
		70410
	],
	"./prism-magma.min": [
		44475,
		44475
	],
	"./prism-magma.min.js": [
		44475,
		44475
	],
	"./prism-makefile": [
		71694,
		71694
	],
	"./prism-makefile.js": [
		71694,
		71694
	],
	"./prism-makefile.min": [
		6828,
		6828
	],
	"./prism-makefile.min.js": [
		6828,
		6828
	],
	"./prism-markdown": [
		64746,
		64746
	],
	"./prism-markdown.js": [
		64746,
		64746
	],
	"./prism-markdown.min": [
		16205,
		16205
	],
	"./prism-markdown.min.js": [
		16205,
		16205
	],
	"./prism-markup": [
		61687,
		61687
	],
	"./prism-markup-templating": [
		31559,
		31559
	],
	"./prism-markup-templating.js": [
		31559,
		31559
	],
	"./prism-markup-templating.min": [
		49837,
		49837
	],
	"./prism-markup-templating.min.js": [
		49837,
		49837
	],
	"./prism-markup.js": [
		61687,
		61687
	],
	"./prism-markup.min": [
		90950,
		90950
	],
	"./prism-markup.min.js": [
		90950,
		90950
	],
	"./prism-mata": [
		54732,
		54732
	],
	"./prism-mata.js": [
		54732,
		54732
	],
	"./prism-mata.min": [
		62397,
		62397
	],
	"./prism-mata.min.js": [
		62397,
		62397
	],
	"./prism-matlab": [
		97146,
		97146
	],
	"./prism-matlab.js": [
		97146,
		97146
	],
	"./prism-matlab.min": [
		57068,
		57068
	],
	"./prism-matlab.min.js": [
		57068,
		57068
	],
	"./prism-maxscript": [
		40594,
		40594
	],
	"./prism-maxscript.js": [
		40594,
		40594
	],
	"./prism-maxscript.min": [
		4202,
		4202
	],
	"./prism-maxscript.min.js": [
		4202,
		4202
	],
	"./prism-mel": [
		89542,
		89542
	],
	"./prism-mel.js": [
		89542,
		89542
	],
	"./prism-mel.min": [
		54876,
		54876
	],
	"./prism-mel.min.js": [
		54876,
		54876
	],
	"./prism-mermaid": [
		34706,
		34706
	],
	"./prism-mermaid.js": [
		34706,
		34706
	],
	"./prism-mermaid.min": [
		86744,
		86744
	],
	"./prism-mermaid.min.js": [
		86744,
		86744
	],
	"./prism-metafont": [
		34866,
		34866
	],
	"./prism-metafont.js": [
		34866,
		34866
	],
	"./prism-metafont.min": [
		26066,
		26066
	],
	"./prism-metafont.min.js": [
		26066,
		26066
	],
	"./prism-mizar": [
		2885,
		2885
	],
	"./prism-mizar.js": [
		2885,
		2885
	],
	"./prism-mizar.min": [
		63050,
		63050
	],
	"./prism-mizar.min.js": [
		63050,
		63050
	],
	"./prism-mongodb": [
		47230,
		47230
	],
	"./prism-mongodb.js": [
		47230,
		47230
	],
	"./prism-mongodb.min": [
		8609,
		8609
	],
	"./prism-mongodb.min.js": [
		8609,
		8609
	],
	"./prism-monkey": [
		3200,
		3200
	],
	"./prism-monkey.js": [
		3200,
		3200
	],
	"./prism-monkey.min": [
		36476,
		36476
	],
	"./prism-monkey.min.js": [
		36476,
		36476
	],
	"./prism-moonscript": [
		20287,
		20287
	],
	"./prism-moonscript.js": [
		20287,
		20287
	],
	"./prism-moonscript.min": [
		63260,
		63260
	],
	"./prism-moonscript.min.js": [
		63260,
		63260
	],
	"./prism-n1ql": [
		67814,
		67814
	],
	"./prism-n1ql.js": [
		67814,
		67814
	],
	"./prism-n1ql.min": [
		64852,
		64852
	],
	"./prism-n1ql.min.js": [
		64852,
		64852
	],
	"./prism-n4js": [
		38015,
		38015
	],
	"./prism-n4js.js": [
		38015,
		38015
	],
	"./prism-n4js.min": [
		73783,
		73783
	],
	"./prism-n4js.min.js": [
		73783,
		73783
	],
	"./prism-nand2tetris-hdl": [
		59219,
		59219
	],
	"./prism-nand2tetris-hdl.js": [
		59219,
		59219
	],
	"./prism-nand2tetris-hdl.min": [
		97639,
		97639
	],
	"./prism-nand2tetris-hdl.min.js": [
		97639,
		97639
	],
	"./prism-naniscript": [
		20755,
		20755
	],
	"./prism-naniscript.js": [
		20755,
		20755
	],
	"./prism-naniscript.min": [
		62031,
		62031
	],
	"./prism-naniscript.min.js": [
		62031,
		62031
	],
	"./prism-nasm": [
		29888,
		29888
	],
	"./prism-nasm.js": [
		29888,
		29888
	],
	"./prism-nasm.min": [
		22903,
		22903
	],
	"./prism-nasm.min.js": [
		22903,
		22903
	],
	"./prism-neon": [
		80130,
		80130
	],
	"./prism-neon.js": [
		80130,
		80130
	],
	"./prism-neon.min": [
		41814,
		41814
	],
	"./prism-neon.min.js": [
		41814,
		41814
	],
	"./prism-nevod": [
		64641,
		64641
	],
	"./prism-nevod.js": [
		64641,
		64641
	],
	"./prism-nevod.min": [
		26912,
		26912
	],
	"./prism-nevod.min.js": [
		26912,
		26912
	],
	"./prism-nginx": [
		25467,
		25467
	],
	"./prism-nginx.js": [
		25467,
		25467
	],
	"./prism-nginx.min": [
		1280,
		1280
	],
	"./prism-nginx.min.js": [
		1280,
		1280
	],
	"./prism-nim": [
		99621,
		99621
	],
	"./prism-nim.js": [
		99621,
		99621
	],
	"./prism-nim.min": [
		35923,
		35923
	],
	"./prism-nim.min.js": [
		35923,
		35923
	],
	"./prism-nix": [
		95093,
		95093
	],
	"./prism-nix.js": [
		95093,
		95093
	],
	"./prism-nix.min": [
		38700,
		38700
	],
	"./prism-nix.min.js": [
		38700,
		38700
	],
	"./prism-nsis": [
		29446,
		29446
	],
	"./prism-nsis.js": [
		29446,
		29446
	],
	"./prism-nsis.min": [
		2146,
		2146
	],
	"./prism-nsis.min.js": [
		2146,
		2146
	],
	"./prism-objectivec": [
		40525,
		40525
	],
	"./prism-objectivec.js": [
		40525,
		40525
	],
	"./prism-objectivec.min": [
		68164,
		68164
	],
	"./prism-objectivec.min.js": [
		68164,
		68164
	],
	"./prism-ocaml": [
		46707,
		46707
	],
	"./prism-ocaml.js": [
		46707,
		46707
	],
	"./prism-ocaml.min": [
		12347,
		12347
	],
	"./prism-ocaml.min.js": [
		12347,
		12347
	],
	"./prism-odin": [
		51164,
		51164
	],
	"./prism-odin.js": [
		51164,
		51164
	],
	"./prism-odin.min": [
		19096,
		19096
	],
	"./prism-odin.min.js": [
		19096,
		19096
	],
	"./prism-opencl": [
		99392,
		99392
	],
	"./prism-opencl.js": [
		99392,
		99392
	],
	"./prism-opencl.min": [
		38115,
		38115
	],
	"./prism-opencl.min.js": [
		38115,
		38115
	],
	"./prism-openqasm": [
		54481,
		54481
	],
	"./prism-openqasm.js": [
		54481,
		54481
	],
	"./prism-openqasm.min": [
		9356,
		9356
	],
	"./prism-openqasm.min.js": [
		9356,
		9356
	],
	"./prism-oz": [
		71209,
		71209
	],
	"./prism-oz.js": [
		71209,
		71209
	],
	"./prism-oz.min": [
		82592,
		82592
	],
	"./prism-oz.min.js": [
		82592,
		82592
	],
	"./prism-parigp": [
		19497,
		19497
	],
	"./prism-parigp.js": [
		19497,
		19497
	],
	"./prism-parigp.min": [
		22881,
		22881
	],
	"./prism-parigp.min.js": [
		22881,
		22881
	],
	"./prism-parser": [
		20617,
		20617
	],
	"./prism-parser.js": [
		20617,
		20617
	],
	"./prism-parser.min": [
		27321,
		27321
	],
	"./prism-parser.min.js": [
		27321,
		27321
	],
	"./prism-pascal": [
		76719,
		76719
	],
	"./prism-pascal.js": [
		76719,
		76719
	],
	"./prism-pascal.min": [
		81046,
		81046
	],
	"./prism-pascal.min.js": [
		81046,
		81046
	],
	"./prism-pascaligo": [
		2019,
		2019
	],
	"./prism-pascaligo.js": [
		2019,
		2019
	],
	"./prism-pascaligo.min": [
		35594,
		35594
	],
	"./prism-pascaligo.min.js": [
		35594,
		35594
	],
	"./prism-pcaxis": [
		77753,
		77753
	],
	"./prism-pcaxis.js": [
		77753,
		77753
	],
	"./prism-pcaxis.min": [
		14601,
		14601
	],
	"./prism-pcaxis.min.js": [
		14601,
		14601
	],
	"./prism-peoplecode": [
		95270,
		95270
	],
	"./prism-peoplecode.js": [
		95270,
		95270
	],
	"./prism-peoplecode.min": [
		28007,
		28007
	],
	"./prism-peoplecode.min.js": [
		28007,
		28007
	],
	"./prism-perl": [
		90360,
		90360
	],
	"./prism-perl.js": [
		90360,
		90360
	],
	"./prism-perl.min": [
		77082,
		77082
	],
	"./prism-perl.min.js": [
		77082,
		77082
	],
	"./prism-php": [
		90706,
		90706
	],
	"./prism-php-extras": [
		1818,
		1818
	],
	"./prism-php-extras.js": [
		1818,
		1818
	],
	"./prism-php-extras.min": [
		24945,
		24945
	],
	"./prism-php-extras.min.js": [
		24945,
		24945
	],
	"./prism-php.js": [
		90706,
		90706
	],
	"./prism-php.min": [
		82121,
		82121
	],
	"./prism-php.min.js": [
		82121,
		82121
	],
	"./prism-phpdoc": [
		29836,
		29836
	],
	"./prism-phpdoc.js": [
		29836,
		29836
	],
	"./prism-phpdoc.min": [
		21558,
		21558
	],
	"./prism-phpdoc.min.js": [
		21558,
		21558
	],
	"./prism-plant-uml": [
		70106,
		70106
	],
	"./prism-plant-uml.js": [
		70106,
		70106
	],
	"./prism-plant-uml.min": [
		8475,
		8475
	],
	"./prism-plant-uml.min.js": [
		8475,
		8475
	],
	"./prism-plsql": [
		99712,
		99712
	],
	"./prism-plsql.js": [
		99712,
		99712
	],
	"./prism-plsql.min": [
		26398,
		26398
	],
	"./prism-plsql.min.js": [
		26398,
		26398
	],
	"./prism-powerquery": [
		32534,
		32534
	],
	"./prism-powerquery.js": [
		32534,
		32534
	],
	"./prism-powerquery.min": [
		40209,
		40209
	],
	"./prism-powerquery.min.js": [
		40209,
		40209
	],
	"./prism-powershell": [
		86777,
		86777
	],
	"./prism-powershell.js": [
		86777,
		86777
	],
	"./prism-powershell.min": [
		74346,
		74346
	],
	"./prism-powershell.min.js": [
		74346,
		74346
	],
	"./prism-processing": [
		79685,
		79685
	],
	"./prism-processing.js": [
		79685,
		79685
	],
	"./prism-processing.min": [
		99872,
		99872
	],
	"./prism-processing.min.js": [
		99872,
		99872
	],
	"./prism-prolog": [
		11130,
		11130
	],
	"./prism-prolog.js": [
		11130,
		11130
	],
	"./prism-prolog.min": [
		98140,
		98140
	],
	"./prism-prolog.min.js": [
		98140,
		98140
	],
	"./prism-promql": [
		84659,
		84659
	],
	"./prism-promql.js": [
		84659,
		84659
	],
	"./prism-promql.min": [
		11083,
		11083
	],
	"./prism-promql.min.js": [
		11083,
		11083
	],
	"./prism-properties": [
		56018,
		56018
	],
	"./prism-properties.js": [
		56018,
		56018
	],
	"./prism-properties.min": [
		54779,
		54779
	],
	"./prism-properties.min.js": [
		54779,
		54779
	],
	"./prism-protobuf": [
		50605,
		50605
	],
	"./prism-protobuf.js": [
		50605,
		50605
	],
	"./prism-protobuf.min": [
		17257,
		17257
	],
	"./prism-protobuf.min.js": [
		17257,
		17257
	],
	"./prism-psl": [
		45002,
		45002
	],
	"./prism-psl.js": [
		45002,
		45002
	],
	"./prism-psl.min": [
		32695,
		32695
	],
	"./prism-psl.min.js": [
		32695,
		32695
	],
	"./prism-pug": [
		9352,
		9352
	],
	"./prism-pug.js": [
		9352,
		9352
	],
	"./prism-pug.min": [
		32763,
		32763
	],
	"./prism-pug.min.js": [
		32763,
		32763
	],
	"./prism-puppet": [
		30194,
		30194
	],
	"./prism-puppet.js": [
		30194,
		30194
	],
	"./prism-puppet.min": [
		18383,
		18383
	],
	"./prism-puppet.min.js": [
		18383,
		18383
	],
	"./prism-pure": [
		31300,
		31300
	],
	"./prism-pure.js": [
		31300,
		31300
	],
	"./prism-pure.min": [
		96345,
		96345
	],
	"./prism-pure.min.js": [
		96345,
		96345
	],
	"./prism-purebasic": [
		23437,
		23437
	],
	"./prism-purebasic.js": [
		23437,
		23437
	],
	"./prism-purebasic.min": [
		92651,
		92651
	],
	"./prism-purebasic.min.js": [
		92651,
		92651
	],
	"./prism-purescript": [
		96062,
		96062
	],
	"./prism-purescript.js": [
		96062,
		96062
	],
	"./prism-purescript.min": [
		61549,
		61549
	],
	"./prism-purescript.min.js": [
		61549,
		61549
	],
	"./prism-python": [
		17479,
		17479
	],
	"./prism-python.js": [
		17479,
		17479
	],
	"./prism-python.min": [
		50876,
		50876
	],
	"./prism-python.min.js": [
		50876,
		50876
	],
	"./prism-q": [
		80835,
		80835
	],
	"./prism-q.js": [
		80835,
		80835
	],
	"./prism-q.min": [
		22890,
		22890
	],
	"./prism-q.min.js": [
		22890,
		22890
	],
	"./prism-qml": [
		37013,
		37013
	],
	"./prism-qml.js": [
		37013,
		37013
	],
	"./prism-qml.min": [
		17635,
		17635
	],
	"./prism-qml.min.js": [
		17635,
		17635
	],
	"./prism-qore": [
		22106,
		22106
	],
	"./prism-qore.js": [
		22106,
		22106
	],
	"./prism-qore.min": [
		25034,
		25034
	],
	"./prism-qore.min.js": [
		25034,
		25034
	],
	"./prism-qsharp": [
		95633,
		95633
	],
	"./prism-qsharp.js": [
		95633,
		95633
	],
	"./prism-qsharp.min": [
		35284,
		35284
	],
	"./prism-qsharp.min.js": [
		35284,
		35284
	],
	"./prism-r": [
		46494,
		46494
	],
	"./prism-r.js": [
		46494,
		46494
	],
	"./prism-r.min": [
		22687,
		22687
	],
	"./prism-r.min.js": [
		22687,
		22687
	],
	"./prism-racket": [
		62671,
		62671
	],
	"./prism-racket.js": [
		62671,
		62671
	],
	"./prism-racket.min": [
		20864,
		20864
	],
	"./prism-racket.min.js": [
		20864,
		20864
	],
	"./prism-reason": [
		75529,
		75529
	],
	"./prism-reason.js": [
		75529,
		75529
	],
	"./prism-reason.min": [
		17330,
		17330
	],
	"./prism-reason.min.js": [
		17330,
		17330
	],
	"./prism-regex": [
		44319,
		44319
	],
	"./prism-regex.js": [
		44319,
		44319
	],
	"./prism-regex.min": [
		44439,
		44439
	],
	"./prism-regex.min.js": [
		44439,
		44439
	],
	"./prism-rego": [
		7828,
		7828
	],
	"./prism-rego.js": [
		7828,
		7828
	],
	"./prism-rego.min": [
		67201,
		67201
	],
	"./prism-rego.min.js": [
		67201,
		67201
	],
	"./prism-renpy": [
		15097,
		15097
	],
	"./prism-renpy.js": [
		15097,
		15097
	],
	"./prism-renpy.min": [
		23760,
		23760
	],
	"./prism-renpy.min.js": [
		23760,
		23760
	],
	"./prism-rescript": [
		18185,
		18185
	],
	"./prism-rescript.js": [
		18185,
		18185
	],
	"./prism-rescript.min": [
		67614,
		67614
	],
	"./prism-rescript.min.js": [
		67614,
		67614
	],
	"./prism-rest": [
		94830,
		94830
	],
	"./prism-rest.js": [
		94830,
		94830
	],
	"./prism-rest.min": [
		58185,
		58185
	],
	"./prism-rest.min.js": [
		58185,
		58185
	],
	"./prism-rip": [
		20848,
		20848
	],
	"./prism-rip.js": [
		20848,
		20848
	],
	"./prism-rip.min": [
		30955,
		30955
	],
	"./prism-rip.min.js": [
		30955,
		30955
	],
	"./prism-roboconf": [
		76328,
		76328
	],
	"./prism-roboconf.js": [
		76328,
		76328
	],
	"./prism-roboconf.min": [
		80513,
		80513
	],
	"./prism-roboconf.min.js": [
		80513,
		80513
	],
	"./prism-robotframework": [
		34618,
		34618
	],
	"./prism-robotframework.js": [
		34618,
		34618
	],
	"./prism-robotframework.min": [
		51561,
		51561
	],
	"./prism-robotframework.min.js": [
		51561,
		51561
	],
	"./prism-ruby": [
		45470,
		45470
	],
	"./prism-ruby.js": [
		45470,
		45470
	],
	"./prism-ruby.min": [
		41663,
		41663
	],
	"./prism-ruby.min.js": [
		41663,
		41663
	],
	"./prism-rust": [
		70457,
		70457
	],
	"./prism-rust.js": [
		70457,
		70457
	],
	"./prism-rust.min": [
		37829,
		37829
	],
	"./prism-rust.min.js": [
		37829,
		37829
	],
	"./prism-sas": [
		41404,
		41404
	],
	"./prism-sas.js": [
		41404,
		41404
	],
	"./prism-sas.min": [
		91860,
		91860
	],
	"./prism-sas.min.js": [
		91860,
		91860
	],
	"./prism-sass": [
		80567,
		80567
	],
	"./prism-sass.js": [
		80567,
		80567
	],
	"./prism-sass.min": [
		83453,
		83453
	],
	"./prism-sass.min.js": [
		83453,
		83453
	],
	"./prism-scala": [
		66706,
		66706
	],
	"./prism-scala.js": [
		66706,
		66706
	],
	"./prism-scala.min": [
		79627,
		79627
	],
	"./prism-scala.min.js": [
		79627,
		79627
	],
	"./prism-scheme": [
		83809,
		83809
	],
	"./prism-scheme.js": [
		83809,
		83809
	],
	"./prism-scheme.min": [
		43958,
		43958
	],
	"./prism-scheme.min.js": [
		43958,
		43958
	],
	"./prism-scss": [
		81320,
		81320
	],
	"./prism-scss.js": [
		81320,
		81320
	],
	"./prism-scss.min": [
		56674,
		56674
	],
	"./prism-scss.min.js": [
		56674,
		56674
	],
	"./prism-shell-session": [
		91187,
		91187
	],
	"./prism-shell-session.js": [
		91187,
		91187
	],
	"./prism-shell-session.min": [
		45338,
		45338
	],
	"./prism-shell-session.min.js": [
		45338,
		45338
	],
	"./prism-smali": [
		52690,
		52690
	],
	"./prism-smali.js": [
		52690,
		52690
	],
	"./prism-smali.min": [
		59855,
		59855
	],
	"./prism-smali.min.js": [
		59855,
		59855
	],
	"./prism-smalltalk": [
		54549,
		54549
	],
	"./prism-smalltalk.js": [
		54549,
		54549
	],
	"./prism-smalltalk.min": [
		22489,
		22489
	],
	"./prism-smalltalk.min.js": [
		22489,
		22489
	],
	"./prism-smarty": [
		20685,
		20685
	],
	"./prism-smarty.js": [
		20685,
		20685
	],
	"./prism-smarty.min": [
		20215,
		20215
	],
	"./prism-smarty.min.js": [
		20215,
		20215
	],
	"./prism-sml": [
		84196,
		84196
	],
	"./prism-sml.js": [
		84196,
		84196
	],
	"./prism-sml.min": [
		71240,
		71240
	],
	"./prism-sml.min.js": [
		71240,
		71240
	],
	"./prism-solidity": [
		20474,
		20474
	],
	"./prism-solidity.js": [
		20474,
		20474
	],
	"./prism-solidity.min": [
		21338,
		21338
	],
	"./prism-solidity.min.js": [
		21338,
		21338
	],
	"./prism-solution-file": [
		57421,
		57421
	],
	"./prism-solution-file.js": [
		57421,
		57421
	],
	"./prism-solution-file.min": [
		80625,
		80625
	],
	"./prism-solution-file.min.js": [
		80625,
		80625
	],
	"./prism-soy": [
		86062,
		86062
	],
	"./prism-soy.js": [
		86062,
		86062
	],
	"./prism-soy.min": [
		92545,
		92545
	],
	"./prism-soy.min.js": [
		92545,
		92545
	],
	"./prism-sparql": [
		55560,
		55560
	],
	"./prism-sparql.js": [
		55560,
		55560
	],
	"./prism-sparql.min": [
		22969,
		22969
	],
	"./prism-sparql.min.js": [
		22969,
		22969
	],
	"./prism-splunk-spl": [
		61050,
		61050
	],
	"./prism-splunk-spl.js": [
		61050,
		61050
	],
	"./prism-splunk-spl.min": [
		76255,
		76255
	],
	"./prism-splunk-spl.min.js": [
		76255,
		76255
	],
	"./prism-sqf": [
		9859,
		9859
	],
	"./prism-sqf.js": [
		9859,
		9859
	],
	"./prism-sqf.min": [
		21601,
		21601
	],
	"./prism-sqf.min.js": [
		21601,
		21601
	],
	"./prism-sql": [
		37642,
		37642
	],
	"./prism-sql.js": [
		37642,
		37642
	],
	"./prism-sql.min": [
		36785,
		36785
	],
	"./prism-sql.min.js": [
		36785,
		36785
	],
	"./prism-squirrel": [
		51120,
		51120
	],
	"./prism-squirrel.js": [
		51120,
		51120
	],
	"./prism-squirrel.min": [
		61059,
		61059
	],
	"./prism-squirrel.min.js": [
		61059,
		61059
	],
	"./prism-stan": [
		54662,
		54662
	],
	"./prism-stan.js": [
		54662,
		54662
	],
	"./prism-stan.min": [
		47935,
		47935
	],
	"./prism-stan.min.js": [
		47935,
		47935
	],
	"./prism-stata": [
		26727,
		26727
	],
	"./prism-stata.js": [
		26727,
		26727
	],
	"./prism-stata.min": [
		16934,
		16934
	],
	"./prism-stata.min.js": [
		16934,
		16934
	],
	"./prism-stylus": [
		31457,
		31457
	],
	"./prism-stylus.js": [
		31457,
		31457
	],
	"./prism-stylus.min": [
		62210,
		62210
	],
	"./prism-stylus.min.js": [
		62210,
		62210
	],
	"./prism-supercollider": [
		53955,
		53955
	],
	"./prism-supercollider.js": [
		53955,
		53955
	],
	"./prism-supercollider.min": [
		21003,
		21003
	],
	"./prism-supercollider.min.js": [
		21003,
		21003
	],
	"./prism-swift": [
		25564,
		25564
	],
	"./prism-swift.js": [
		25564,
		25564
	],
	"./prism-swift.min": [
		26255,
		26255
	],
	"./prism-swift.min.js": [
		26255,
		26255
	],
	"./prism-systemd": [
		95082,
		95082
	],
	"./prism-systemd.js": [
		95082,
		95082
	],
	"./prism-systemd.min": [
		67696,
		67696
	],
	"./prism-systemd.min.js": [
		67696,
		67696
	],
	"./prism-t4-cs": [
		56972,
		56972
	],
	"./prism-t4-cs.js": [
		56972,
		56972
	],
	"./prism-t4-cs.min": [
		89890,
		89890
	],
	"./prism-t4-cs.min.js": [
		89890,
		89890
	],
	"./prism-t4-templating": [
		76176,
		76176
	],
	"./prism-t4-templating.js": [
		76176,
		76176
	],
	"./prism-t4-templating.min": [
		42589,
		42589
	],
	"./prism-t4-templating.min.js": [
		42589,
		42589
	],
	"./prism-t4-vb": [
		6145,
		6145
	],
	"./prism-t4-vb.js": [
		6145,
		6145
	],
	"./prism-t4-vb.min": [
		31242,
		31242
	],
	"./prism-t4-vb.min.js": [
		31242,
		31242
	],
	"./prism-tap": [
		77251,
		77251
	],
	"./prism-tap.js": [
		77251,
		77251
	],
	"./prism-tap.min": [
		49534,
		49534
	],
	"./prism-tap.min.js": [
		49534,
		49534
	],
	"./prism-tcl": [
		21382,
		21382
	],
	"./prism-tcl.js": [
		21382,
		21382
	],
	"./prism-tcl.min": [
		43025,
		43025
	],
	"./prism-tcl.min.js": [
		43025,
		43025
	],
	"./prism-textile": [
		72591,
		72591
	],
	"./prism-textile.js": [
		72591,
		72591
	],
	"./prism-textile.min": [
		11832,
		11832
	],
	"./prism-textile.min.js": [
		11832,
		11832
	],
	"./prism-toml": [
		14265,
		14265
	],
	"./prism-toml.js": [
		14265,
		14265
	],
	"./prism-toml.min": [
		90366,
		90366
	],
	"./prism-toml.min.js": [
		90366,
		90366
	],
	"./prism-tremor": [
		24114,
		24114
	],
	"./prism-tremor.js": [
		24114,
		24114
	],
	"./prism-tremor.min": [
		39830,
		39830
	],
	"./prism-tremor.min.js": [
		39830,
		39830
	],
	"./prism-tsx": [
		79904,
		79904
	],
	"./prism-tsx.js": [
		79904,
		79904
	],
	"./prism-tsx.min": [
		63402,
		63402
	],
	"./prism-tsx.min.js": [
		63402,
		63402
	],
	"./prism-tt2": [
		44376,
		44376
	],
	"./prism-tt2.js": [
		44376,
		44376
	],
	"./prism-tt2.min": [
		27497,
		27497
	],
	"./prism-tt2.min.js": [
		27497,
		27497
	],
	"./prism-turtle": [
		55394,
		55394
	],
	"./prism-turtle.js": [
		55394,
		55394
	],
	"./prism-turtle.min": [
		21885,
		21885
	],
	"./prism-turtle.min.js": [
		21885,
		21885
	],
	"./prism-twig": [
		45180,
		45180
	],
	"./prism-twig.js": [
		45180,
		45180
	],
	"./prism-twig.min": [
		64229,
		64229
	],
	"./prism-twig.min.js": [
		64229,
		64229
	],
	"./prism-typescript": [
		52619,
		52619
	],
	"./prism-typescript.js": [
		52619,
		52619
	],
	"./prism-typescript.min": [
		34586,
		34586
	],
	"./prism-typescript.min.js": [
		34586,
		34586
	],
	"./prism-typoscript": [
		47254,
		47254
	],
	"./prism-typoscript.js": [
		47254,
		47254
	],
	"./prism-typoscript.min": [
		78605,
		78605
	],
	"./prism-typoscript.min.js": [
		78605,
		78605
	],
	"./prism-unrealscript": [
		92939,
		92939
	],
	"./prism-unrealscript.js": [
		92939,
		92939
	],
	"./prism-unrealscript.min": [
		88189,
		88189
	],
	"./prism-unrealscript.min.js": [
		88189,
		88189
	],
	"./prism-uorazor": [
		70177,
		70177
	],
	"./prism-uorazor.js": [
		70177,
		70177
	],
	"./prism-uorazor.min": [
		92909,
		92909
	],
	"./prism-uorazor.min.js": [
		92909,
		92909
	],
	"./prism-uri": [
		61597,
		61597
	],
	"./prism-uri.js": [
		61597,
		61597
	],
	"./prism-uri.min": [
		3648,
		3648
	],
	"./prism-uri.min.js": [
		3648,
		3648
	],
	"./prism-v": [
		76289,
		76289
	],
	"./prism-v.js": [
		76289,
		76289
	],
	"./prism-v.min": [
		48420,
		48420
	],
	"./prism-v.min.js": [
		48420,
		48420
	],
	"./prism-vala": [
		5816,
		5816
	],
	"./prism-vala.js": [
		5816,
		5816
	],
	"./prism-vala.min": [
		5580,
		5580
	],
	"./prism-vala.min.js": [
		5580,
		5580
	],
	"./prism-vbnet": [
		96225,
		96225
	],
	"./prism-vbnet.js": [
		96225,
		96225
	],
	"./prism-vbnet.min": [
		34805,
		34805
	],
	"./prism-vbnet.min.js": [
		34805,
		34805
	],
	"./prism-velocity": [
		18971,
		18971
	],
	"./prism-velocity.js": [
		18971,
		18971
	],
	"./prism-velocity.min": [
		63141,
		63141
	],
	"./prism-velocity.min.js": [
		63141,
		63141
	],
	"./prism-verilog": [
		60173,
		60173
	],
	"./prism-verilog.js": [
		60173,
		60173
	],
	"./prism-verilog.min": [
		92828,
		92828
	],
	"./prism-verilog.min.js": [
		92828,
		92828
	],
	"./prism-vhdl": [
		41758,
		41758
	],
	"./prism-vhdl.js": [
		41758,
		41758
	],
	"./prism-vhdl.min": [
		10430,
		10430
	],
	"./prism-vhdl.min.js": [
		10430,
		10430
	],
	"./prism-vim": [
		76766,
		76766
	],
	"./prism-vim.js": [
		76766,
		76766
	],
	"./prism-vim.min": [
		9267,
		9267
	],
	"./prism-vim.min.js": [
		9267,
		9267
	],
	"./prism-visual-basic": [
		97772,
		97772
	],
	"./prism-visual-basic.js": [
		97772,
		97772
	],
	"./prism-visual-basic.min": [
		89,
		89
	],
	"./prism-visual-basic.min.js": [
		89,
		89
	],
	"./prism-warpscript": [
		3169,
		3169
	],
	"./prism-warpscript.js": [
		3169,
		3169
	],
	"./prism-warpscript.min": [
		46333,
		46333
	],
	"./prism-warpscript.min.js": [
		46333,
		46333
	],
	"./prism-wasm": [
		50877,
		50877
	],
	"./prism-wasm.js": [
		50877,
		50877
	],
	"./prism-wasm.min": [
		89110,
		89110
	],
	"./prism-wasm.min.js": [
		89110,
		89110
	],
	"./prism-web-idl": [
		42753,
		42753
	],
	"./prism-web-idl.js": [
		42753,
		42753
	],
	"./prism-web-idl.min": [
		36506,
		36506
	],
	"./prism-web-idl.min.js": [
		36506,
		36506
	],
	"./prism-wgsl": [
		6286,
		6286
	],
	"./prism-wgsl.js": [
		6286,
		6286
	],
	"./prism-wgsl.min": [
		28139,
		28139
	],
	"./prism-wgsl.min.js": [
		28139,
		28139
	],
	"./prism-wiki": [
		54230,
		54230
	],
	"./prism-wiki.js": [
		54230,
		54230
	],
	"./prism-wiki.min": [
		96049,
		96049
	],
	"./prism-wiki.min.js": [
		96049,
		96049
	],
	"./prism-wolfram": [
		85644,
		85644
	],
	"./prism-wolfram.js": [
		85644,
		85644
	],
	"./prism-wolfram.min": [
		68342,
		68342
	],
	"./prism-wolfram.min.js": [
		68342,
		68342
	],
	"./prism-wren": [
		19115,
		19115
	],
	"./prism-wren.js": [
		19115,
		19115
	],
	"./prism-wren.min": [
		98144,
		98144
	],
	"./prism-wren.min.js": [
		98144,
		98144
	],
	"./prism-xeora": [
		93201,
		93201
	],
	"./prism-xeora.js": [
		93201,
		93201
	],
	"./prism-xeora.min": [
		83153,
		83153
	],
	"./prism-xeora.min.js": [
		83153,
		83153
	],
	"./prism-xml-doc": [
		52962,
		52962
	],
	"./prism-xml-doc.js": [
		52962,
		52962
	],
	"./prism-xml-doc.min": [
		17569,
		17569
	],
	"./prism-xml-doc.min.js": [
		17569,
		17569
	],
	"./prism-xojo": [
		88391,
		88391
	],
	"./prism-xojo.js": [
		88391,
		88391
	],
	"./prism-xojo.min": [
		29818,
		29818
	],
	"./prism-xojo.min.js": [
		29818,
		29818
	],
	"./prism-xquery": [
		20149,
		20149
	],
	"./prism-xquery.js": [
		20149,
		20149
	],
	"./prism-xquery.min": [
		93555,
		93555
	],
	"./prism-xquery.min.js": [
		93555,
		93555
	],
	"./prism-yaml": [
		57010,
		57010
	],
	"./prism-yaml.js": [
		57010,
		57010
	],
	"./prism-yaml.min": [
		58434,
		58434
	],
	"./prism-yaml.min.js": [
		58434,
		58434
	],
	"./prism-yang": [
		44425,
		44425
	],
	"./prism-yang.js": [
		44425,
		44425
	],
	"./prism-yang.min": [
		24825,
		24825
	],
	"./prism-yang.min.js": [
		24825,
		24825
	],
	"./prism-zig": [
		32947,
		32947
	],
	"./prism-zig.js": [
		32947,
		32947
	],
	"./prism-zig.min": [
		11170,
		11170
	],
	"./prism-zig.min.js": [
		11170,
		11170
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 96316;
module.exports = webpackAsyncContext;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [48307,24415,48158,49774,92888,40179], function() { return __webpack_exec__(71069); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);